// ig — checkin/quickCheck/stepTracker blocks translated.
export const ig = {
  "common": {
    "loading": "Ọ na-ebu...",
    "save": "Chekwaa",
    "cancel": "Kagbuo",
    "delete": "Hichapụ",
    "edit": "Dezie",
    "close": "Mechie",
    "confirm": "Kwado",
    "back": "Laghachi",
    "next": "Ihe ọzọ",
    "submit": "Nyefee",
    "search": "Chọọ",
    "select": "Họrọ",
    "or": "Ma ọ bụ",
    "and": "na",
    "note": "Rịba ama",
    "viewAll": "Lee ha niile",
    "learnMore": "Mụtakwuo ihe",
    "getStarted": "Bido ugbu a",
    "continue": "Gaa n'ihu",
    "saving": "Ọ na-echekwa…"
  },
  "nav": {
    "dashboard": "Ụlọ",
    "nutrition": "Ihe oriri",
    "family": "Ezinaụlọ",
    "care": "Ọrụ anyị",
    "careShort": "Ọrụ",
    "checkIn": "Nnyocha",
    "insights": "Nghọta",
    "trends": "Otú ọ na-aga",
    "habits": "Àgwà",
    "medications": "Ọgwụ",
    "expertSupport": "Nkwado ndị ọkachamara",
    "profile": "Ihu gị",
    "healthHub": "Ebe Ahụike",
    "support": "Nkwado",
    "wellness": "Ahụike zuru oke",
    "education": "Mmụta",
    "community": "Ndị enyi",
    "preventiveHealth": "Nchekwa Ahụike",
    "womensHealth": "Ahụike Ụmụ nwaanyị",
    "reminders": "Ihe ncheta ahụike",
    "meals": "Nri",
    "orders": "Ihe azụrụ",
    "subscription": "Ndebanye aha",
    "logout": "Pụọ"
  },

  "navShort": {
    "dashboard": "Ụlọ",
    "nutrition": "Nri",
    "family": "Ezinụlọ",
    "care": "Ọrụ",
    "support": "Enyemaka",
    "profile": "Profaịlụ"
  },
  "auth": {
    "login": "Banye",
    "register": "Mepụta akaụntụ",
    "logout": "Pụọ",
    "email": "Email",
    "password": "Paswọd",
    "name": "Aha gị niile",
    "forgotPassword": "Ị chefuru paswọd gị?",
    "noAccount": "Ị nweghị akaụntụ?",
    "haveAccount": "Ị nwere akaụntụ kale?",
    "signInHere": "Banye ebe a",
    "signUpHere": "Debanye aha ebe a",
    "welcomeBack": "Nnọọ ọzọ!",
    "getStarted": "Ka anyị malite",
    "biometricLogin": "Banye site na ihu ma ọ bụ mkpịsị aka",
    "biometricHelper": "Jiri mkpịsị aka, Face ID, ma ọ bụ Windows Hello",
    "vendorLogin": "Ntinye nke onye na-ere ahịa",
    "createOne": "Mepụta otu",
    "tagline": "Na-elekọta ahụike gị — nnyocha dị mfe kwa ụbọchị.",
    "takes30s": "Ọ naghị ewe ihe karịrị sekọnd iri atọ",
    "emailPlaceholder": "aha@atụmatụ.com",
    "passwordPlaceholder": "Tinye paswọd gị",
    "checking": "Ọ na-enyocha…",
    "continue": "Gaa n'ihu",
    "secureMessage": "Ọ dị nchebe ma bụrụ nke onwe — data gị echekwara",
    "biometricSoon": "Ntinye ihu/mkpịsị aka — Na-abịa n'oge adịghị anya",
    "sessionExpired": "Oge ntinye gị agwụla. Biko banye ọzọ ka i nwee ike gaa n'ihu.",
    "showPassword": "Gosi okwuntughe",
    "hidePassword": "Zụọ okwuntughe",
    "vendor": {
      "title": "Ntinye nke Ndị Ohu Azụmahịa",
      "subtitle": "Banye na dashboard azụmahịa HealthLoop gị",
      "businessEmail": "Email azụmahịa",
      "emailPlaceholder": "vendor@business.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Na-abanye...",
      "signIn": "Banye",
      "notVendorYet": "Ị hụbeghị ka onye ohu azụmahịa anyị?",
      "registerBusiness": "Debanye aha azụmahịa gị",
      "areYouUser": "Ị bụ onye ọrụ?",
      "userLogin": "Ntinye nke onye ọrụ",
      "welcomeBackToast": "Nnọọ ọzọ!",
      "genericError": "Ntinye adaala. Biko nwaa ọzọ."
    },
    "admin": {
      "backToUserLogin": "Ntinye nke onye ọrụ",
      "title": "Ntinye nke Admin",
      "restrictedBadge": "Nke amachibidoro",
      "tagline": "HealthLoop operator console — a chọrọ nzere admin.",
      "emailLabel": "Email nke admin",
      "emailPlaceholder": "admin@yourdomain.com",
      "passwordLabel": "Okwuntughe",
      "passwordPlaceholder": "Tinye okwuntughe admin gị",
      "signingIn": "Na-abanye...",
      "submit": "Banye na console admin",
      "secureNote": "Njikọ dị nchebe · emebere nnọkọ nzuzo",
      "restrictedTitle": "Ebe a bụ maka naanị ndị admin.",
      "restrictedBody": "I banyela n'akaụntụ gị, mana i nweghị ohere admin. Pụọ ka ị nwaa akaụntụ ọzọ, ma ọ bụ laghachi n'isi ngwa anyị.",
      "signOut": "Pụọ",
      "backToApp": "Laghachi na ngwa"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Kedu ka ahụ gị dị taa?",
      "subtitle": "Nnyocha ngwa ngwa — ọ naghị ewe karịa sekọnd 60"
    },
    "section1": {
      "title": "Gịnị ka ị na-ahụ n'ahụ gị taa?",
      "hint": "(Họrọ nke ọ bụla metụtara gị)"
    },
    "environment": {
      "title": "Ebe ị nọ taa",
      "hint": "Nyere anyị aka ịghọta ebe ị nọ"
    },
    "basicChecks": {
      "title": "Nnyocha ndị dị mkpa",
      "hint": "Ọ bụrụ na ị chọrọ, mana ọ na-enyere aka"
    },
    "validation": {
      "pickOne": "Biko zaa opekata mpe otu ajụjụ"
    },
    "submit": {
      "cta": "Nweta Nghọta Ahụ Ike M",
      "saving": "A na-esekwaba ya...",
      "analyzing": "Anyị na-enyocha usoro ahụ ike gị...",
      "savedToast": "✅ Esekwala nnyocha gị! Anyị na-enyocha usoro ahụ ike gị..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Ihe Ntụle Nzọụkwụ",
      "subtitle": "Eziokwu na nlekọta ihe omume gị",
      "backToDashboard": "Laghachi na dashboard"
    },
    "today": {
      "title": "Nzọụkwụ taa",
      "goalProgress": "{{current}} / {{goal}} nzọụkwụ",
      "goalReached": "I ruru ihe ị chọrọ — ezigbo ọrụ!",
      "keepGoing": "Gaa n'ihu — ị nọ n'ụzọ ziri ezi."
    },
    "streak": {
      "label": "Ụbọchị n'usoro ugbu a",
      "days": "Ụbọchị {{count}}",
      "daysPlural": "Ụbọchị {{count}}"
    },
    "badges": {
      "title": "Ihe nrite",
      "empty": "Ị ga-enweta ihe nrite ka ị na-eme nke a oge niile."
    },
    "reminders": {
      "title": "Nchetara mmegharị ahụ",
      "hint": "Nchetara dị nwayọọ ka ị gaa ije nkenke mgbe ị nọdụrụ ọdụ ogologo oge.",
      "enabled": "Agbanwere ya",
      "disabled": "Akwụsịrị ya"
    },
    "insights": {
      "weeklyAverage": "Nkezi maka izu",
      "weeklyGoal": "Ihe ịchọrọ imezu n'izu"
    },
    "actions": {
      "connect": "Jikọọ ihe na-agụ nzọụkwụ",
      "manualLog": "Dee nzọụkwụ gị n'onwe gị",
      "changeGoal": "Gbanwee ihe ịchọrọ imezu kwa ụbọchị"
    }
  },
  "checkin": {
    "header": {
      "title": "Nnyocha Ahụ Ike Kwa Ụbọchị",
      "subtitle": "Ọ naghị ewe ihe karịrị sekọnd 60",
      "restDayLink": "Ihe anaghị amasi m taa"
    },
    "snapshot": {
      "title": "Ihe ngosi gị, emelitere ya",
      "healthScore": "Akara ahụ ike",
      "todayTasks": "Ihe omume taa",
      "dayStreak": "ụbọchị n'usoro"
    },
    "resume": {
      "banner": "I malitela ebe ị kwụsịrị",
      "startFresh": "Malite ọhụrụ",
      "dismiss": "Wepụ ya"
    },
    "progress": {
      "allSet": "Ihe niile adịla njikere",
      "step": "Nzọụkwụ {{current}} n'ime {{total}}",
      "ariaLabel": "Ọganihu nnyocha kwa ụbọchị: {{done}} n'ime {{total}} akụkụ agwụla"
    },
    "insights": {
      "title": "Nghọta Maka Ahụ Ike Gị",
      "subtitle": "Nke emere maka gị taa",
      "insightForYou": "Nghọta maka gị",
      "simpleActions": "Ihe dị mfe ị nwere ike ime",
      "whenToSeekHelp": "Mgbe ị ga-achọ enyemaka",
      "nhsAdvice": "Ọ bụrụ na i nwere nchekasị, kpọtụrụ NHS 111 ma ọ bụ dọkịta gị",
      "backToDashboard": "Laghachi na Dashboard",
      "newCheckIn": "Nnyocha Ọhụrụ",
      "disclaimer": "HealthLoop na-enye ntuziaka maka ọdịmma ahụ ike, ọ bụghị nchọpụta ọrịa."
    },
    "restDay": {
      "title": "Izu ike so n'usoro ahụ ike.",
      "body": "Anyị ga-anọ ebe a echi, mgbe ọ bụla ị dịla njikere.",
      "streakNote": "Ụbọchị n'usoro gị agbanweghị — ọ na-ezu ike kwa.",
      "backToDashboard": "Laghachi na dashboard",
      "changedMind": "N'ezie, m ga-achọ ime nnyocha m."
    },
    "feelings": {
      "title": "Kedu ka ahụ gị dị taa?",
      "hint": "Họrọ nke ọ bụla metụtara gị",
      "tired": "Ike ọgwụgwụ",
      "headache": "Isi ọwụwa",
      "stressed": "Nchegbu ma ọ bụ ibu arọ",
      "pain": "Mgbu n'ahụ",
      "okay": "Ahụ m dị mma taa"
    },
    "basics": {
      "title": "Ihe ndị dị mkpa",
      "sleepQ": "I hiri ụra nke ọma n'abalị ụnyaahụ?",
      "waterQ": "I ñụọla mmiri zuru ezu taa?",
      "foodQ": "I rila nri nke ọma taa?",
      "activityQ": "Kedu ka i siri mee ihe taa?",
      "yes": "Ee",
      "notReally": "Mbanụ",
      "notYet": "Enbeghị",
      "notActive": "Anọ m jụụ",
      "lightActivity": "Ihe omume dị mfe",
      "active": "Emere m ọtụtụ ihe"
    },
    "mind": {
      "title": "Uche & Ike",
      "stressQ": "Kedu ka nchegbu gị dị taa?",
      "moodQ": "Kedu ka obi gị dị taa?",
      "energyQ": "Kedu ka ike ahụ gị dị taa?",
      "low": "Ọ dị ala",
      "moderate": "Ọ dị n'etiti",
      "high": "Ọ dị elu",
      "neutral": "Anọ m otu ebe",
      "good": "Ọ dị mma",
      "okay": "Ọ dị mma"
    },
    "day": {
      "title": "Ụbọchị gị",
      "routineQ": "I soro usoro ihe omume gị nke ụbọchị taa?",
      "yes": "Ee",
      "no": "Mba"
    },
    "environment": {
      "title": "Ebe ị nọ taa",
      "describeQ": "Kedu ka ị ga-esi kọwaa ebe ị nọ?",
      "comfortable": "😊 Ọ dị mma",
      "slightlyUncomfortable": "😐 Ọ dịghị mma nke ukwuu",
      "challenging": "😓 Ọ siri ike",
      "affectedQ": "Ebe ị nọ ọ metụtara otú obi gị dị?",
      "yes": "Ee",
      "no": "Mba",
      "exposureLabel": "Ihe ndị nwere ike imetụta gị (họrọ nke ọ bụla metụtara gị)",
      "heat": "🌡️ Okpomọkụ",
      "cold": "❄️ Ntụyi",
      "noise": "🔊 Mkpọtụ",
      "dustSmoke": "💨 Uzuzu ma ọ bụ anwụrụ ọkụ",
      "crowded": "👥 Igwe mmadụ",
      "none": "✅ Onweghị"
    },
    "submit": {
      "analyzing": "Anyị na-enyocha usoro ahụ ike gị...",
      "cta": "Hụ Nghọta Ahụ Ike M"
    },
    "toast": {
      "savedFull": "Esekwala nnyocha gị! Emelitere dashboard gị.",
      "savedShort": "Esekwala nnyocha gị."
    }
  },
  "onboarding": {
    "welcome": "Nnọọ",
    "completeSetup": "Mechaa nhazi ahụ",
    "stepProgress": "Nzọụkwụ {{step}} n'ime {{total}}",
    "percentComplete": "{{percent}}% agwụla",
    "welcomeToast": "Nnọọ na HealthLoop! E mepụtala ihu gị.",
    "errorAgeRange": "Biko họrọ afọ ole ị dị",
    "errorCountry": "Biko họrọ obodo gị",
    "errorGoal": "Biko họrọ ebumnuche ahụike gị kachasị mkpa",
    "errorCuisine": "Biko họrọ opekata mpe otu ụdị nri ị hụrụ n'anya",
    "errorGeneric": "Ndebanye aha ahụ agaghị. Biko nwaa ọzọ.",
    "step1Title": "Nnọọ na HealthLoop! 👋",
    "step1Subtitle": "Ka anyị hazie njem ahụike gị maka gị",
    "ageRangeLabel": "Afọ ole ka ị dị?",
    "genderLabel": "Nwoke ka ọ bụ Nwaanyị (Nhọrọ)",
    "gender_male": "Nwoke",
    "gender_female": "Nwaanyị",
    "gender_non-binary": "Nke ọ bụla",
    "gender_prefer_not_to_say": "Achọghị m ikwu",
    "step2Title": "Ebee ka i bi? 🌍",
    "step2Subtitle": "Nke a ga-enyere anyị aka ịkwado nri ndị dị n'obodo gị",
    "countryLabel": "Họrọ obodo gị",
    "country_uk": "United Kingdom",
    "country_nigeria": "Nigeria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenya",
    "country_south_africa": "South Africa",
    "country_usa": "United States",
    "country_canada": "Canada",
    "country_india": "India",
    "country_jamaica": "Jamaica",
    "country_other": "Obodo ọzọ",
    "step3Title": "Gịnị bụ isi ebumnuche gị? 🎯",
    "step3Subtitle": "Họrọ ihe kacha mkpa ị chọrọ imezu n'ahụike gị",
    "additionalGoals": "E nwere ihe ọzọ ị chọrọ? (Nhọrọ)",
    "goal_weight_loss": "Ibelata ibu",
    "goalDesc_weight_loss": "Belata ibu n'ụzọ dị mma",
    "goal_weight_maintenance": "Idebe ibu otu ebe",
    "goalDesc_weight_maintenance": "Nọgide n'ibu ị nwere ugbu a",
    "goal_muscle_gain": "Iwulite ahụ",
    "goalDesc_muscle_gain": "Nweta ume na ahụ siri ike",
    "goal_general_wellness": "Ahụike zuru oke",
    "goalDesc_general_wellness": "Mmezi ahụike n'ozuzu",
    "goal_better_sleep": "Ụra dị mma",
    "goalDesc_better_sleep": "Mee ka ụra gị ka mma",
    "goal_reduce_stress": "Ibelata nchekasị",
    "goalDesc_reduce_stress": "Lụso nchekasị ọgụ nke ọma",
    "goal_increase_energy": "Inwetakwu ume",
    "goalDesc_increase_energy": "Nwee ume karịa",
    "step4Title": "Nhọrọ nri 🍽️",
    "step4Subtitle": "Họrọ nri ndị na-amasị gị na ihe ndị ị naghị eri",
    "cuisineLabel": "Nri ndị kacha amasị gị",
    "cuisineHint": "Họrọ opekata mpe otu (ị nwere ike ịhọrọ ọtụtụ)",
    "dietaryLabel": "Ihe ị naghị eri (Nhọrọ)",
    "diet_vegetarian": "Onye na-eri naanị akwụkwọ nri",
    "diet_vegan": "Vegan",
    "diet_halal": "Halal",
    "diet_kosher": "Kosher",
    "diet_gluten_free": "Enweghị Gluten",
    "diet_dairy_free": "Enweghị mmiri ara ehi",
    "diet_pescatarian": "Onye na-eri azụ",
    "step5Title": "Ọrịa ma ọ bụ ọnọdụ ahụike 🏥",
    "step5Subtitle": "Nhọrọ — ọ na-enyere anyị aka inye gị ndụmọdụ kacha mma",
    "conditionsLabel": "Ị nwere nke ọ bụla n'ime ọrịa ndị a?",
    "conditionsHint": "Ozi a bụ nke nzuzo, ọ ga-enyere anyị aka ịhazi ọrụ anyị maka gị",
    "condition_diabetes": "Ọrịa shuga",
    "condition_hypertension": "Ọbara mgbali elu",
    "condition_heart_disease": "Ọrịa obi",
    "condition_thyroid": "Nsogbu Thyroid",
    "condition_celiac": "Ọrịa Celiac",
    "condition_ibs": "Nsogbu afọ (IBS)",
    "condition_none": "Enweghị nke ọ bụla",
    "privacyTitle": "Echekwara data gị",
    "privacyBody": "Echekwara ozi gị n'ụzọ pụrụ iche. Anyị na-eji ozi a naanị iji hazie nri, ndụmọdụ ahụike, na ozi maka gị. Anyị agaghị agwa ndị ọzọ gbasara data gị ma ọ bụrụ na i nyeghị ikike.",
    "trackMedication": "Achọrọ m idetụ ọgwụ m na-aṅụ",
    "specialistInterest": "Mmasị m dị na ịhụ ndị dọkịta ọkachamara",
    "welcomeTitle": "Nnọọ na HealthLoop! 👋",
    "welcomeSubtitle": "Ka anyị hazie amamihe wellness gị n'ụzọ dị mfe site n'enyemaka AI",
    "stepLabel": "Nkeji {{current}} n'ime {{total}}",
    "skipForNow": "Mee ya ma emechaa",
    "skipToast": "I nwere ike mechaa nhazi a n'ime profaịlụ gị oge ọ bụla",
    "back": "Laghachi azụ",
    "next": "Gaba n'ihu",
    "completing": "Ọ na-emecha...",
    "complete": "Mechaa Nhazi",
    "successToast": "Nnọọ na HealthLoop! Ahaziela profaịlụ gị ugbu a 🎉",
    "failureToast": "Nhazi ahụ agaghị nke ọma",
    "validation": {
      "basicInfo": "Biko dejupụta ozi ndị bụ isi",
      "pickGoal": "Biko họrọ ma ọ dịkarịa ala otu ebumnuche wellness",
      "pickPrimary": "Biko họrọ ebumnuche gị kacha mkpa",
      "pickRegion": "Biko họrọ mpaghara ọdịnala gị maka aro nri kacha mma",
      "pickFocus": "Biko họrọ ebe ị kacha chọọ ilekwasị anya"
    },
    "step1": {
      "title": "Profaịlụ Wellness Gị",
      "description": "Nyere anyị aka iwulite amamihe wellness nke dịịrị naanị gị",
      "age": "Afọ ole ka ị dị *",
      "agePlaceholder": "dgz., 30",
      "height": "Ogologo (cm) *",
      "heightPlaceholder": "dgz., 170",
      "weight": "Ịdị arọ (kg) *",
      "weightPlaceholder": "dgz., 70"
    },
    "step2": {
      "title": "Ebumnuche Wellness Gị",
      "description": "Họrọ nke ọ bụla metụtara gị, maba họrọ nke kacha mkpa",
      "primaryLabel": "Họrọ Ebumnuche Gị Kacha Mkpa *",
      "primaryBadge": "Nke kacha mkpa"
    },
    "step3": {
      "title": "🌍 Ọdịnala & Nri Masịrị Gị",
      "description": "Nyere anyị aka ka anyị mara nri anyị ga-atụnyere gị",
      "regionLabel": "Mpaghara Ọdịnala *",
      "regionHint": "Họrọ ebe ị siri pụta maka aro nri ga-amasị gị",
      "countryLabel": "Obodo (Nhọrọ)",
      "countryPlaceholder": "dgz., Nigeria, Kenya, Jamaica",
      "countryHint": "Maka aro nri ndị kachasị mma",
      "foodPrefLabel": "Ụdị Nri Dị Iche Iche"
    },
    "step4": {
      "title": "Ebe Ị Kacha Lekwasị Anya",
      "description": "Họrọ akụkụ nke kacha mkpa ka ị rụpụta ọrụ na ya"
    },
    "step5": {
      "title": "Nhọrọ Gị",
      "description": "Hazie otu HealthLoop ga-esi na-arụrụ gị ọrụ",
      "trackMeds": "Soro usoro ọgwụ",
      "trackMedsHint": "Mee ka anyị na-echetara gị ma na-esochi oge ị na-aṅụ ọgwụ",
      "specialist": "Ị chọrọ nkwado ndị ọkachamara",
      "specialistHint": "Nweta ohere ịgwa ndị ọkachamara n'ihe gbasara wellness, nri, na ahụike uche okwu",
      "confidentialTitle": "Nkwado Nzuzo:",
      "confidentialBody": "Ozi gị niile nọ na nchekwa, anyị na-eji ya naanị iji nye gị ndụmọdụ wellness nke ga-enyere gị aka."
    },
    "step6": {
      "title": "Nhazi Nri Gị",
      "description": "Nyere anyị aka tụnyere gị nri ndị masịrị gị na ndị ga-enyere ahụ gị aka",
      "cuisinesLabel": "Ụdị Nri Masịrị Gị (Nhọrọ)",
      "cuisinesHint": "Họrọ nri ndị ị kacha hụ n'anya",
      "dietaryLabel": "Nri Ị Na-adịghị Eri (Nhọrọ)",
      "dietaryHint": "Họrọ nke ọ bụla metụtara gị",
      "allergiesLabel": "Ihe Na-asọ Gị N'ahụ (Nhọrọ)",
      "allergiesHint": "Họrọ ihe nri ọ bụla na-asọ gị",
      "personalisedTitle": "Nri Ahaziri Gị:",
      "personalisedBody": "Anyị ga-eji ihe ndị a ị họọrọ tụnyere gị nri ndị masịrị gị. I nwere ike ịgbanwe ha oge ọ bụla na Settings."
    },
    "healthGoals": {
      "better_sleep": "Ụra Ka Mma",
      "reduce_stress": "Belata Nchegbu",
      "increase_energy": "Mee Ka Ike Jụọ Gị",
      "weight_management": "Nlekọta Arọ",
      "improve_fitness": "Mee Ahụ Ike",
      "better_nutrition": "Nri Na-edozi Ahụ",
      "mental_wellness": "Wellness Uche",
      "chronic_condition": "Nlekọta Ahụike Ogologo"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Ahụike Uche",
        "description": "Lekwasị anya n'obi ụtọ, nchegbu, na ịdị mma uche"
      },
      "physical_fitness": {
        "label": "Mmega Ahụ",
        "description": "Lekwasị anya na mmega ahụ, ume, na mmegharị ahụ"
      },
      "nutrition": {
        "label": "Nri",
        "description": "Lekwasị anya n'ụdị nri na oriri na-edozi ahụ"
      },
      "sleep": {
        "label": "Ụra Dị Mma",
        "description": "Lekwasị anya na nzu ike na usoro ụra"
      },
      "stress_management": {
        "label": "Nlekọta Nchegbu",
        "description": "Lekwasị anya na nzu ike na ibelata nchegbu"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "West Africa",
        "description": "Nri Nigerian, Ghanaian, na Senegalese"
      },
      "east_african": {
        "label": "East Africa",
        "description": "Nri Kenyan, Ethiopian, na Tanzanian"
      },
      "north_african": {
        "label": "North Africa",
        "description": "Nri Moroccan na Egyptian"
      },
      "southern_african": {
        "label": "Southern Africa",
        "description": "Nri South African"
      },
      "caribbean": {
        "label": "Caribbean",
        "description": "Nri Jamaican, Trinidadian, na Barbadian"
      },
      "middle_eastern": {
        "label": "Middle East",
        "description": "Nri Lebanese, Palestinian, na Syrian"
      },
      "south_asian": {
        "label": "South Asia",
        "description": "Nri Indian, Pakistani, na Bangladeshi"
      },
      "east_asian": {
        "label": "East Asia",
        "description": "Nri Chinese, Japanese, na Korean"
      },
      "southeast_asian": {
        "label": "Southeast Asia",
        "description": "Nri Thai, Vietnamese, na Indonesian"
      },
      "western": {
        "label": "Western",
        "description": "Nri American na European"
      },
      "latin_american": {
        "label": "Latin America",
        "description": "Nri Mexican, Brazilian, na Argentine"
      },
      "mediterranean": {
        "label": "Mediterranean",
        "description": "Nri Greek, Italian, na Spanish"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Nri Ọdịnala",
        "description": "Nri kachasị n'ala nna gị"
      },
      "mixed": {
        "label": "Ngwakọta",
        "description": "Nri obodo gị na nri mba ofesi"
      },
      "international": {
        "label": "Nri Mba Ofesi",
        "description": "Nri dị iche iche sitere n'ụwa niile"
      }
    },
    "cuisines": {
      "west_african": "West African",
      "caribbean": "Caribbean",
      "mediterranean": "Mediterranean",
      "asian": "Asian",
      "western": "Western",
      "indian": "Indian",
      "middle_eastern": "Middle Eastern",
      "general": "Ụdị Nri Niile"
    },
    "dietary": {
      "vegetarian": "Vegetarian",
      "vegan": "Vegan",
      "pescatarian": "Pescatarian",
      "gluten_free": "Gluten-Free",
      "dairy_free": "Dairy-Free",
      "low_carb": "Low-Carb"
    },
    "allergies": {
      "nuts": "Nuts",
      "shellfish": "Shellfish",
      "dairy": "Dairy",
      "eggs": "Akwa",
      "soy": "Soy",
      "gluten": "Gluten"
    },
    "cuisine_nigerian": "Nri Naịjirịa",
    "cuisine_ghanaian": "Nri Gana",
    "cuisine_senegalese": "Nri Senegal",
    "cuisine_kenyan": "Nri Kenya",
    "cuisine_ethiopian": "Nri Etiopia",
    "cuisine_moroccan": "Nri Moroko",
    "cuisine_south_african": "Nri Saụt Afrịka",
    "cuisine_jamaican": "Nri Jamaịka",
    "cuisine_trinidadian": "Nri Trinidad",
    "cuisine_lebanese": "Nri Lebanọn",
    "cuisine_turkish": "Nri Tọki",
    "cuisine_greek": "Nri Grik",
    "cuisine_italian": "Nri Italo",
    "cuisine_french": "Nri Frenchi",
    "cuisine_british": "Nri Briten",
    "cuisine_indian_south": "Nri Ndịda India",
    "cuisine_indian_north": "Nri Ugwu India",
    "cuisine_pakistani": "Nri Pakịstan",
    "cuisine_japanese": "Nri Japan",
    "cuisine_chinese": "Nri Chaina",
    "cuisine_korean": "Nri Koria",
    "cuisine_vietnamese": "Nri Vietnam",
    "cuisine_thai": "Nri Taịland",
    "cuisine_filipino": "Nri Filipins",
    "cuisine_american": "Nri Amerịka",
    "cuisine_mexican": "Nri Meksiko",
    "cuisine_brazilian": "Nri Brazil",
    "cuisine_peruvian": "Nri Peru"
  },
  "dashboard": {
    "welcome": "Nnọọ ọzọ",
    "greeting": "Ndewo",
    "goodMorning": "Ụtụtụ ọma",
    "goodAfternoon": "Ehihie ọma",
    "goodEvening": "Mgbede ọma",
    "tagline": "Obere nzọụkwụ ahụike na-eweta mgbanwe na-adịgide adịgide",
    "microcopy": "Njem ahụike gị dị mkpa.",
    "welcomeSubtitleMorning1": "Mmalite dị jụụ maka ụbọchị ahụ.",
    "welcomeSubtitleMorning2": "Obi dị m ụtọ na i batara n'ụtụtụ a.",
    "welcomeSubtitleMorning3": "Obere oge ị wepụtara dị mkpa.",
    "welcomeSubtitleAfternoon1": "Atụrụ m anya na ụbọchị gị na-aga nke ọma.",
    "welcomeSubtitleAfternoon2": "Nnọọ ọzọ na HealthLoop.",
    "welcomeSubtitleAfternoon3": "Kuru ume — ị na-eme nke ọma.",
    "welcomeSubtitleEvening1": "Mụ na gị na-ezu ike mgbede a.",
    "welcomeSubtitleEvening2": "Mmechi dị nwayọọ maka ụbọchị ahụ.",
    "welcomeSubtitleEvening3": "Nnọọ ọzọ na mgbede a.",
    "title": "Usoro ọgụgụ isi maka nchekwa ahụike gị",
    "subtitle": "Soro ya, mụta, ma mee ihe tupu nsogbu abawanye",
    "summary": "Nchịkọta ọgụgụ isi ahụike gị",
    "summaryDesc": "Nghọta ozugbo gbasara nchekwa, mmụta, na ahụike",
    "comprehensiveSupport": "Nkwado zuru oke na nchekwa, mmụta, na ahụike zuru oke",
    "todayCheckIn": "Nnyocha nke taa",
    "quickActions": "Ihe ị ga-eme ngwa ngwa",
    "healthOverview": "Nlele ahụike",
    "recentActivity": "Ihe ndị i mere nso a",
    "viewAll": "Lee ha niile",
    "preventiveHealth": "Nchekwa Ahụike",
    "preventiveHealthDesc": "Ndepụta kwa ụbọchị, nlebanya ahụike & ịdọ aka ná ntị",
    "education": "Mmụta",
    "educationDesc": "Nghọta dabeere na sayensị, akụkọ ahụike & ndụmọdụ ndị ọkachamara",
    "engagement": "Mmekọrịta",
    "engagementDesc": "Ihe mgbaru ọsọ ndị enyi, ndepụta àgwà & nkwado ọha",
    "wellness": "Ahụike zuru oke",
    "wellnessDesc": "Ihe oriri mara mma, nhazi ibi ndụ & ahụike n'ozuzu",
    "todaysInsight": "Nghọta nke taa",
    "wellnessScore": "Akara Ahụike",
    "healthStreak": "Oge Ahụike",
    "days": "ụbọchị",
    "logHealth": "Detuo Ahụike",
    "getEducated": "Mụta Ihe",
    "communityChallenge": "Ihe mgbaru ọsọ ndị enyi",
    "checkWellness": "Lelee Ahụike",
    "verified": "Enyochara",
    "joinCommunity": "Soro ndị enyi anyị",
    "personalizedPlan": "Atụmatụ gị",
    "score": "Akara",
    "checkIns": "nnyocha",
    "habits": "àgwà",
    "preventive": "Nchekwa",
    "healthMetrics": "Ihe nlele ahụike",
    "trackMetrics": "Soro ihe nlele gị",
    "startTracking": "Malite idetu",
    "logMetrics": "Detuo ihe nlele",
    "dailyInsight": "Nghọta nke ụbọchị",
    "learnAbout": "Mụta maka nchekwa ahụike taa",
    "articlesAvailable": "akụkọ dị",
    "browseArticles": "Gụọ akụkọ ndị ahụ",
    "currentStreak": "Oge ị nọgiderela",
    "keepGoing": "Gaa n'ihu!",
    "startStreak": "Malite oge gị",
    "checkIn": "Nnyocha",
    "nutritionPlan": "Atụmatụ Ihe Oriri",
    "mealsPlanned": "nri a haziri",
    "viewPlan": "Lee atụmatụ",
    "planYourWeek": "Hazie izu gị",
    "moodStress": "Mmetụta & Nchekasị",
    "howFeeling": "Olee otú ọ dị gị?",
    "logWellness": "Detuo Ahụike",
    "medications": "Ọgwụ",
    "noMeds": "Enweghị ọgwụ a na-eso",
    "addMedications": "Tinye ọgwụ gị",
    "daysTracked": "Ụbọchị e deturu",
    "noHabits": "Enweghị àgwà e deturu",
    "startTrackingHabits": "Malite idetu àgwà",
    "insights": "Nghọta",
    "noInsights": "Enweghị nghọta dị ugbu a",
    "completeFirstPlan": "Mechaa atụmatụ mbụ gị",
    "noCheckIns": "Enweghị nnyocha e mere",
    "startFirstCheckIn": "Mee nnyocha mbụ gị"
  },
  "support": {
    "title": "Nkwado",
    "subtitle": "Chọta azịza, kpọtụrụ anyị, ma ọ bụ kọọ nsogbu",
    "backToSettings": "Laghachi na ntọala",
    "privacyBanner": "Anyị na-ejikwa arịrịọ nkwado gị n'ụzọ nzuzo na nchekwa. Ozi ahụike gị ga-anọ n'ụzọ nzuzo.",
    "section1": "Ngalaba 1",
    "section2": "Ngalaba 2",
    "section3": "Ngalaba 3",
    "section4": "Ngalaba 4",
    "navHelpCenter": "Ebe Enyemaka",
    "navContact": "Kpọtụrụ Nkwado",
    "navHealth": "Ọrụ Ahụike",
    "navTechnical": "Nkwado Nkà na Ụzụ",
    "helpCenterTitle": "Ebe Enyemaka",
    "helpCenterSubtitle": "Chọọ ajụjụ ndị a na-ajụkarị ma nweta azịza ngwa ngwa.",
    "contactTitle": "Kpọtụrụ Nkwado",
    "contactSubtitle": "Kpọtụrụ ndị otu anyị site n'ụzọ kacha mma masịrị gị.",
    "healthServicesTitle": "Ọrụ Ahụike",
    "healthServicesSubtitle": "Soro ndị ọkachamara n'ihe gbasara nlekọta ọgwụ na ụlọ ọgwụ kparịta ụka.",
    "technicalTitle": "Nkwado Nkà na Ụzụ",
    "technicalSubtitle": "Kọọ gbasara mmejọ ma ọ bụ nsogbu nkà na ụzụ n'ụzọ zuru ezu.",
    "searchPlaceholder": "Chọọ ajụjụ ndị a na-ajụkarị…",
    "liveChat": "Kparịta ụka Ugbu a",
    "emailUs": "Zitere anyị ozi ịntanetị",
    "callBack": "Hazie ka anyị kpọghachiri gị",
    "sendMessage": "Ziga ozi",
    "medicationTracking": "Nsochi ọgwụ",
    "specialistAccess": "Nnweta onye ọkachamara",
    "videoConsultation": "Nleba anya na vidiyo",
    "reportBug": "Kọọ mmejọ",
    "yourName": "Aha gị",
    "yourEmail": "Ozi ịntanetị gị",
    "subject": "Isiokwu",
    "message": "Ozi",
    "phone": "Ekwentị",
    "description": "Nkọwa",
    "submit": "Ziga",
    "successTitle": "Ezigala ozi",
    "successDescription": "Anyị ga-aza gị n'ime awa 24–48.",
    "healthDisclaimer": "Maka ihe mberede ahụike, kpọtụrụ ndị ọrụ mberede dị nso. HealthLoop anaghị anọchi anya nlekọta ahụike ndị ọkachamara."
  },
  "nutrition": {
    "smartNutrition": "Nri Amamihe",
    "basedOnGoal": "Dabere na ebumnuche gị:",
    "personalizedData": "Ahaziri ya dabere na ozi ahụike gị kachasị nso",
    "evidenceBased": "Nri sayensị kwadoro dịka akụkụ nke atụmatụ ahụike mgbochi gị",
    "todaysMealSuggestions": "Aro nri nke taa",
    "customize": "Hazie ya",
    "breakfast": "Nri ụtụtụ",
    "lunch": "Nri ehihie",
    "dinner": "Nri anyasị",
    "loadingBreakfast": "Na-ebunye nri ụtụtụ...",
    "loadingLunch": "Na-ebunye nri ehihie...",
    "loadingDinner": "Na-ebunye nri anyasị...",
    "cal": "kcal",
    "protein": "protein",
    "swapMeal": "Gbanwee nri",
    "healthyOptionsNearYou": "Nhọrọ nri ahụike dị gị nso",
    "enableLocation": "Gbanye ebe ị nọ",
    "view": "Lee ya",
    "discoverOptions": "Chọta ụlọ nri ahụike, ụlọ ahịa nri, na ndị na-ere nri a kwadebere n'akụkụ gị",
    "cuisinesSelected": "ụdị nri ndị a họọrọ",
    "cuisineSelected": "ụdị nri a họọrọ",
    "dietaryPrefs": "ihe oriri masịrị gị",
    "dietaryPref": "ihe oriri masịrị gị",
    "customizeMeals": "Hazie nri gị",
    "subtitleAdaptive": "Atụmatụ nri ahaziri maka omenala gị na ebumnuche ahụike gị",
    "hideFavorites": "Zobe ndị kacha amasị gị",
    "viewFavorites": "Lee ndị kacha amasị gị",
    "customizeMealsLegacy": "Hazie nri ka ọ kwekọọ na omenala gị na mkpa oriri gị",
    "viewFullPlan": "Lee atụmatụ niile",
    "exploreRecipes": "Chọpụta otu esi esi nri"
  },
  "location": {
    "permissionTitle": "Chọta nhọrọ nri ahụike dị gị nso",
    "permissionDesc": "Ejiri nke a kwado ụlọ nri, ụlọ ahịa, na ndị na-ere nri kwekọrọ na ebumnuche ahụike gị.",
    "howToEnable": "Otu esi agbanye ya:",
    "step1": "Pịa akara mkpọchi 🔒 n'ebe adresị ihe nchọgharị gị",
    "step2": "Chọta ikike maka \"Location\"",
    "step3": "Gbanwee ya ka ọ bụrụ \"Allow\"",
    "step4": "Megharịa ihu akwụkwọ a",
    "refreshPage": "Megharịa Ihu Akwụkwọ",
    "allowLocation": "Kwe ka ebe ị nọ pụta",
    "notNow": "Ọ bụghị ugbu a",
    "denied": "Emechiri ohere ịhụ ebe ị nọ. Ka ị hụ nhọrọ ahụike dị gị nso, ị ga-enye ikike ịhụ ebe ị nọ.",
    "unavailable": "Ozi gbasara ebe ị nọ adịghị ugbu a. Biko lelee ntọala ngwaọrụ gị.",
    "error": "Enweghị ike ịhụ ebe ị nọ. Biko nwaa ọzọ ma ọ bụ lelee ntọala ihe nchọgharị gị.",
    "unsupported": "Ihe nchọgharị gị anaghị akwado ọrụ ebe a nọ. Nwaa iji Chrome, Firefox, ma ọ bụ Safari ọhụrụ.",
    "accessRequired": "Achọrọ Ikike Ịhụ Ebe Ị Nọ"
  },
  "womensHealth": {
    "title": "Ahụike Ụmụ Nwanyị",
    "description": "Soro usoro ịhụ nsọ gị, deba akara mgbaàmà, ma nweta ndụmọdụ ahụike dabere na oge usoro gị dị",
    "cycleTracking": "Nsochi usoro ịhụ nsọ",
    "symptomLogging": "Ndebanye mgbaàmà",
    "phaseInsights": "Ihe omuma nke oge",
    "logPeriod": "Debanye oge ịhụ nsọ",
    "logSymptoms": "Debanye mgbaàmà",
    "insights": "Ihe omuma",
    "tips": "Ndụmọdụ Ahụike",
    "overview": "Nchịkọta",
    "history": "Akụkọ ihe mere eme",
    "startTracking": "Malite nsochi usoro ịhụ nsọ gị"
  },
  "profile": {
    "title": "Profaịlụ",
    "personalInfo": "Ozi Onwe Gị",
    "healthProfile": "Profaịlụ Ahụike",
    "preferences": "Ihe Ndị Masịrị Gị",
    "language": "Asụsụ",
    "selectLanguage": "Họrọ Asụsụ",
    "notifications": "Ịma Ọkwa",
    "privacy": "Nzuzo",
    "security": "Nchebe",
    "quickAccess": "Nnweta Ngwa Ngwa",
    "editProfile": "Dezie Profaịlụ",
    "viewStats": "Lee Ihe Ndekọ",
    "backToDashboard": "Laghachi na Dashboard",
    "womensHealthTitle": "Ahụike Ụmụ Nwanyị",
    "womensHealthDesc": "Nsochi usoro nsọ, mgbaàmà na ndụmọdụ ahụike",
    "healthRemindersTitle": "Ihe Ncheta Ahụike",
    "healthRemindersDesc": "Jikwaa ọkwa gị",
    "manageRemindersDesc": "Jikwaa ihe ncheta gị na ọkwa gị",
    "healthPatternAlerts": "Ịma Ọkwa Usoro Ahụike Gị",
    "supportHelp": "Nkwado na Enyemaka",
    "supportHelpDesc": "Nweta enyemaka, kọọ nsogbu, ma ọ bụ gụọ ajụjụ ndị a na-ajụkarị",
    "admin": "Nchịkwa",
    "adminDesc": "Lee otu a na-esi eji ngwa na omume ndị ọrụ",
    "giveFeedback": "Nye Ntụle",
    "giveFeedbackDesc": "Gwa anyị gbasara ahụmịhe gị na HealthLoop",
    "reportProblem": "Kọọ Nsogbu",
    "reportProblemDesc": "Nyere anyị aka idozi mmejọ na imeziwanye ngwa a",
    "manageHealthInfo": "Jikwaa ozi ahụike mgbochi gị maka ihe omuma ahaziri gị",
    "basicInformation": "Ozi Ndị Isi",
    "fullName": "Aha zuru oke",
    "email": "Ozi ịntanetị",
    "dateOfBirth": "Ụbọchị ọmụmụ",
    "gender": "Nwoke ma ọ bụ Nwanyị",
    "height": "Ogologo (cm)",
    "weight": "Ịdị arọ (kg)",
    "medicalConditions": "Ọnọdụ ahụike",
    "allergies": "Ihe na-ara gị ahụ (Allergies)",
    "personalHealth": "Ahụike Onwe Gị",
    "addCondition": "Tinye ọnọdụ ahụike",
    "addAllergy": "Tinye ihe na-ara gị ahụ",
    "saveChanges": "Chekwaa Mgbanwe",
    "saving": "Na-echekwa...",
    "privacyMessage": "Ozi ahụike gị nwere nchebe dịka ụkpụrụ nlekọta nzuzo siri dị"
  },
  "settings": {
    "title": "Nhazi",
    "general": "Nke Izugbe",
    "account": "Akaụntụ",
    "appearance": "Ọdịdị",
    "languageSettings": "Nhazi Asụsụ",
    "changeLanguage": "Gbanwee Asụsụ",
    "languageNote": "Ihu ngwa a na-agbanwe ozugbo ị họọrọ asụsụ ọhụrụ. Akara asụsụ Afrịka na ndị ọhụrụ a gbakwunyere bụ 'Starter' — nke pụtara na ọ bụ igwe sụgharịrị ya maka nkesa sara mbara, anyị ka na-eche nyocha ndị ọkachamara n'asụsụ ahụ.",
    "languageUpdated": "Emelitela asụsụ nke ọma",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "Ọ bụ igwe sụgharịrị ya — a ka na-eche nyocha onye nwe asụsụ.",
    "regions": {
      "global": "Ụwa niile",
      "european": "Asụsụ ndị Europe",
      "middleEastern": "Asụsụ ndị Middle East",
      "asian": "Asụsụ ndị Eshia",
      "african": "Asụsụ ndị Afrịka"
    }
  },
  "search": {
    "triggerLabel": "Chọọ na HealthLoop",
    "triggerHint": "Nwaa \"ije ụkwụ\", \"ụlọ ọgwụ\" ma ọ bụ \"ime\"",
    "triggerAriaLabel": "Mepee nchọgharị zuru oke",
    "placeholder": "Chọọ ihe ndị dị dika, ihe nlekọta, nkwado…",
    "inputAriaLabel": "Chọọ ihe ndị dị na HealthLoop",
    "modalAriaLabel": "Chọọ HealthLoop",
    "close": "Mechie",
    "clear": "Hichapụ",
    "clearAriaLabel": "Hichapụ nchọgharị",
    "recentSearches": "Ihe ndị ị chọrọ n'oge nso a",
    "tryFor": "Nwaa ịchọ maka",
    "findFeatures": "Chọta ihe ọbụla n'ime obere sekọnd.",
    "searchAcross": "Chọọ na",
    "and": "na",
    "sections": {
      "home": "Obi",
      "nutrition": "Nri n'ahụ",
      "family": "Ezinụlọ",
      "services": "Ọrụ anyị",
      "support": "Nkwado",
      "profile": "Nkọwa gbasara gị"
    },
    "noMatchesFor": "Enweghị ihe dabara na \"{{query}}\"",
    "trySimpler": "Nwaa iji mkpụrụokwu dị mfe dịka ije ụkwụ, nri n'ahụ ma ọ bụ ọkachamara.",
    "comingSoonBadge": "Ọ na-abịa n'oge nso",
    "escToClose": "iji mechie",
    "resultSingular": "{{count}} ihe a chọtara",
    "resultPlural": "{{count}} ihe ndị a chọtara",
    "searchAcrossApp": "Chọọ na ngwa ọrụ a niile"
  },
  "familyMember": {
    "confirmRemove": "Wepụ {{name}} na nlekọta ahụike ezinụlọ?",
    "removed": "E wepụla {{name}} na ezinụlọ",
    "removeFailed": "Enweghị ike iwepụ onye òtù a",
    "viewDetails": "Lee nkọwa ya",
    "edit": "Degharịa",
    "remove": "Wepụ",
    "yearsSuffix": "afọ",
    "healthGoalsLabel": "Ihe mgbaru ọsọ ahụike:",
    "moreSuffix": "ọzọ",
    "activeInsights": "Nkọwa ahụike na-arụ ọrụ",
    "viewAllInsights": "Lee nkọwa niile dị {{count}} →",
    "viewFullProfile": "Lee nkọwa ahụike ya niile",
    "lifeStage": {
      "infant": "Nwa ọhụrụ (0-2)",
      "toddler": "Nwa na-eto eto (2-5)",
      "child": "Nwatakịrị (6-12)",
      "adolescent": "Onye nọ n'afọ iri na ụma (13-17)",
      "adult": "Onye toro eto (18-59)",
      "senior": "Okenye (60+)",
      "unknown": "Amaghị"
    }
  },
  "profileDeep": {
    "backToDashboard": "Laghachi na dashboard",
    "profileCompletion": "Mmezu nke Profaịlụ",
    "healthSummary": "Nchịkọta ahụike",
    "sectionA": "Nkebi A",
    "sectionB": "Nkebi B",
    "sectionC": "Nkebi C",
    "sectionD": "Nkebi D",
    "personalDetails": "Nkọwa onwe onye",
    "healthInformation": "Ozi gbasara ahụike",
    "accountSettings": "Nhazi akaụntụ",
    "fullName": "Aha zuru oke",
    "email": "Email",
    "dob": "Ụbọchị ọmụmụ",
    "gender": "Nwaanyị/Nwoke",
    "genderPlaceholder": "dịka, Nwaanyị, Nwoke, ma ọ bụ ndị ọzọ",
    "height": "Ogo (cm)",
    "heightPlaceholder": "dịka, 170",
    "weight": "Ịdị arọ (kg)",
    "weightPlaceholder": "dịka, 70",
    "allergies": "Ihe na-ara gị ahụ (Allergies)",
    "allergiesPlaceholder": "dịka, Ahụekere",
    "medicalConditions": "Ọrịa ma ọ bụ ọnọdụ ahụike",
    "conditionsPlaceholder": "dịka, Ọbara mgbali elu",
    "medications": "Ọgwụ ndị ị na-aṅụ",
    "medicationsPlaceholder": "dịka, Lisinopril 10mg, kwa ụbọchị",
    "emergencyContact": "Onye a ga-akpọtụrụ n'ihe mberede",
    "emergencyOptional": "(nhọrọ)",
    "emergencyPlaceholder": "dịka, Mama +1-555-0100",
    "emergencyNote": "A ga-ekekọrịta nke a naanị mgbe ị kwetara ka onye ọkachamara hụ ya.",
    "saveChanges": "Chekwaa mgbanwe",
    "saving": "Na-echekwa…",
    "editProfile": "Dezie profaịlụ",
    "cancelEditing": "Hapụ idezi",
    "healthScore": "Akara ahụike",
    "streak": "Ihe ngosi ịdị n'otu",
    "streakDays": "Ụbọchị {{n}}",
    "memberSince": "Onye otu kemgbe",
    "remindersActive": "Ihe ncheta na-arụ ọrụ",
    "conditionsTracked": "Ọnọdụ ndị a na-enyocha",
    "nextAgenda": "Ihe ọzọ ị ga-eme",
    "notificationsReminders": "Ozi ọkwa & ihe ncheta",
    "notificationsRemindersDesc": "Njikwa oge na ụzọ e si enweta ihe ncheta ahụike",
    "emailNudges": "Ihe ncheta email",
    "emailNudgesDesc": "Ihe ncheta dị nwayọ & nchịkọta nke izu",
    "on": "Gbanyụrụ",
    "paused": "A kwụsịtụrụ",
    "privacySecurity": "Nchekwa & Nzuzo",
    "privacySecurityDesc": "Gbanwee paswọọdụ gị iji chebe akaụntụ gị",
    "preferencesTitle": "Ihe ị kachasị mma",
    "preferencesDesc": "Asụsụ, mpaghara, na nhazi onwe",
    "supportHelp": "Nkwado & enyemaka",
    "supportHelpDesc": "Nweta azịza ma kpọtụrụ anyị",
    "giveFeedback": "Nye echiche gị",
    "giveFeedbackDesc": "Gwa anyị ihe anyị ga-emeziwanye",
    "reportProblem": "Kpesa nsogbu",
    "reportProblemDesc": "Ị hụrụ mmejọ na ngwa a? Gwa anyị",
    "adminInsights": "Nnyocha nchịkwa",
    "adminInsightsDesc": "Nnyocha gbasara ojiji ngwa",
    "adminBadge": "Onye nchịkwa",
    "shareWithClinician": "Kekọrịta onye ọkachamara ahụike",
    "shareWithClinicianDesc": "Nchịkọta naanị maka ọgụgụ · ọ na-agwụ n'onwe ya · ị nwere ike ịkwụsị ya mgbe ọ bụla",
    "share": "Kekọrịta",
    "profileMayBeOutOfDate": "Profaịlụ gị nwere ike ọ gaghị abụ nke ọhụrụ",
    "profileMayBeOutOfDateDesc": "Mee ka ozi ahụike gị bụrụ eziokwu maka nduzi ka mma — ọbụna obere mgbanwe (ịdị arọ, ọgwụ) na-enyere anyị aka inye gị nduzi dabara adaba.",
    "updateNow": "Emelite ugbu a",
    "profileUpdateError": "Anyị enweghị ike imelite nhọrọ gị. Biko gbalịa ọzọ.",
    "healthLoopUser": "Onye ọrụ HealthLoop",
    "updatedLabel": "Emelitela",
    "noEntries": "Enwebeghị ozi ọ bụla.",
    "completionComplete": "Profaịlụ gị ezuola. Ugbu a anyị nwere ike inye gị nduzi kacha mma. 💚",
    "completionAlmostThere": "Ọ fọrọ ntakịrị. Nkọwa ole na ole fọdụrụ ga-emeghe ụzọ maka nduzi doro anya.",
    "completionInProgress": "Mezuo profaịlụ gị ka ị nweta nduzi ahụike ka mma.",
    "justNow": "ugbu a",
    "minAgo": "Nkeji {{n}} gara aga",
    "minsAgo": "Nkeji {{n}} gara aga",
    "hourAgo": "Elekere {{n}} gara aga",
    "hoursAgo": "Elekere {{n}} gara aga",
    "dayAgo": "Ụbọchị {{n}} gara aga",
    "daysAgo": "Ụbọchị {{n}} gara aga",
    "checkinDueToday": "Oge nnyocha erugo taa",
    "checkinDueTonight": "Oge nnyocha erugo n'abalị a"
  },
  "supportDeep": {
    "backToSettings": "Laghachi na nhazi",
    "quickNavAria": "Nkebi nkwado",
    "searchPlaceholder": "Chọọ enyemaka…",
    "searchAria": "Chọọ ajụjụ ndị a na-ajụkarị",
    "resultsCount": "{{n}} ihe a chọtara",
    "resultsCountPlural": "{{n}} ihe a chọtara",
    "questionsCount": "{{n}} ajụjụ",
    "liveChatTitle": "Mkparịta ụka Ozugbo",
    "liveChatDesc": "Gwa anyị okwu ugbu a · Mọnde–Fraịde 9am–6pm",
    "startChat": "Malite Mkparịta ụka",
    "liveChatSoonToast": "Mkparịta ụka ozugbo na-abịa n'oge adịghị anya. Tupu oge ahụ, email ga-arụ ọrụ nke ọma.",
    "emailUsTitle": "Zitara anyị Email",
    "emailUsDesc": "Azịza ga-abịa n'ime awa 24–48",
    "copy": "Detuo",
    "emailCopied": "E depụtaghachila email.",
    "contactFormTitle": "Fọm nkwurịta okwu",
    "contactFormDesc": "Zitara anyị ozi — anyị ga-aza gị site na email.",
    "yourNameLabel": "Aha gị *",
    "namePlaceholder": "Jane Doe",
    "yourEmailLabel": "Email gị *",
    "emailPlaceholder": "jane@example.com",
    "subjectOptional": "Isiokwu (nhọrọ)",
    "subjectPlaceholder": "Gịnị ka anyị nwere ike inyere gị aka na ya?",
    "messageLabel": "Ozi *",
    "messagePlaceholder": "Gwa anyị ntakịrị ihe gbasara ihe ị chọrọ.",
    "sending": "Na-eziga…",
    "sendMessage": "Ziga Ozi",
    "messageSent": "E zigala ozi",
    "messageSentDesc": "Anyị ga-aza gị n'ime awa 24–48.",
    "callbackTitle": "Rịọ ka anyị kpọọ gị",
    "callbackDesc": "Anyị ga-akpọghachi gị n'oge dabara gị.",
    "phoneLabel": "Nọmba ekwentị *",
    "phonePlaceholder": "+234 (0) 800 000 0000",
    "preferredTimeLabel": "Oge ị kacha mma (nhọrọ)",
    "preferredTimePlaceholder": "dịka, echi n'ehihie",
    "reasonLabel": "Ihe kpatara ya (nhọrọ)",
    "reasonPlaceholder": "Na nkenke, gịnị ka ị ga-achọ ka anyị kwurịta?",
    "submitting": "Na-eziga…",
    "requestCallback": "Rịọ ka akpọọ gị",
    "callbackRequested": "E deela arịrịọ gị",
    "callbackRequestedDesc": "Anyị ga-akpọtụrụ gị n'ime awa 24.",
    "medicationSupport": "Nkwado maka Ọgwụ",
    "medicationSupportDesc": "Soro usoro ọgwụ gị, ntoputa ọhụrụ, na ihe ncheta.",
    "goToMedications": "Gaa na ngalaba ọgwụ →",
    "specialistConsultation": "Nleba anya nke Ọkachamara",
    "specialistConsultationDesc": "Kpọtụrụ onye ọkachamara ahụike maka nduzi doro anya.",
    "connectExpert": "Kpọtụrụ onye ọkachamara →",
    "videoConsult": "Nkwurịta okwu Vidiyo",
    "videoConsultDesc": "Debanye oge gị na onye ọkachamara site na vidiyo.",
    "bookConsultation": "Debanye oge nleba anya →",
    "premium": "Premium",
    "healthDisclaimer": "HealthLoop na-akwado ahụike gị nke ụbọchị kwa ụbọchị — ọ bụghị maka mberede ahụike dị egwu. Ọ bụrụ na ihe emee na mberede, biko kpọtụrụ ụlọ ọgwụ ma ọ bụ ndị ọrụ mberede dị nso.",
    "categoryLabel": "Ụdị",
    "catBug": "Mmejọ / Bug",
    "catPerformance": "Ọ naghị agba ọsọ",
    "catFeature": "Ihe anaghị arụ ọrụ",
    "catUi": "Nsogbu ọdịdị ngwa",
    "catOther": "Ihe ọzọ",
    "issueTitle": "Isiokwu nsogbu ahụ *",
    "issueTitlePlaceholder": "Nchịkọta dị nkenke",
    "detailedDescription": "Nkọwa zuru ezu *",
    "detailedDescriptionPlaceholder": "Gịnị mere? Gịnị ka ị na-eme mgbe ọ mere? Ime ka anyị mara usoro ị gbasoro ga-enyere anyị aka nke ukwuu.",
    "autoAttachNote": "A ga-ezipụ ozi gbasara ekwentị gị na ihe nchọgharị gị na akpaghị aka.",
    "submitReport": "Ziga Akụkọ",
    "reportSubmitted": "E zigala akụkọ",
    "reportSubmittedDesc": "Ndị otu anyị amaliteela ọrụ na ya.",
    "fillAllFields": "Biko dejupụta ebe niile dị mkpa",
    "problemReportSubmittedToast": "E zigala akụkọ nsogbu gị. Anyị ga-enyocha ya ma kpọtụrụ gị.",
    "messageSentToast": "E zigala ozi gị. Anyị ga-aza gị n'ime awa 24–48.",
    "callRequestedToast": "Arịrịọ oku gị abanyela. Anyị ga-akpọtụrụ gị n'ime awa 24.",
    "submitFailGeneric": "Ozi agaghị. Biko gbalịa ọzọ ma ọ bụ zitara anyị email na {{email}}.",
    "submitFailContact": "Ozi agaghị. Biko zitara {{email}} email ozugbo.",
    "comingSoon": "Na-abịa N'oge Adịghị Anya",
    "specialistRoadmapTitle": "Gwa Onye Ọkachamara Okwu",
    "specialistRoadmapSubtitle": "Enyemaka mmadụ na-abịa n'oge adịghị anya. Ụzọ ndị a ga-anọ ebe a ka enyemaka nọrọ gị nso mgbe niile.",
    "talkToSpecialistTitle": "Gwa Onye Ọkachamara Okwu",
    "talkToSpecialistDesc": "Gwa ndị ọkachamara ahụike okwu ozugbo maka ajụjụ ahụike nke ụbọchị kwa ụbọchị.",
    "bookSpecialistTitle": "Debanye oge na Ọkachamara",
    "bookSpecialistDesc": "Hazi oge gị na onye ọkachamara kwesịrị ekwesị maka ebumnuche gị.",
    "liveHealthGuidanceTitle": "Nduzi Ahụike Ozugbo",
    "liveHealthGuidanceDesc": "Nduzi vidiyo maka mgbaàmà ọrịa, nsonaazụ nyocha (lab), ma ọ bụ atụmatụ nlekọta.",
    "mentalWellnessTitle": "Nkwado Maka Ahụike Pikiche",
    "mentalWellnessDesc": "Nkwado nzuzo sitere n'aka ndị ọkachamara n'echiche mgbe ihe siiri gị ike.",
    "wellnessNavigationTitle": "Nhazi Ụzọ Ahụike",
    "wellnessNavigationDesc": "Usoro nduzi ga-enyere gị aka ịhọrọ ihe kacha mma ị ga-eme ọzọ.",
    "pharmacyRoadmapTitle": "Nkwado Ọgwụ na Farmasi",
    "pharmacyRoadmapSubtitle": "Enyemaka gbasara ụlọ ọgwụ (farmasi) dị n'ime ngalaba Nkwado & Enyemaka.",
    "medicationGuidanceTitle": "Nduzi maka Ọgwụ",
    "medicationGuidanceDesc": "Nduzi n'asụsụ dị mfe gbasara otu esi aṅụ ọgwụ, oge a ga-aṅụ ya, na ọgwụ ndị na-adịghị mma ịgwakọta.",
    "findNearbyPharmacyTitle": "Chọta Farmasi Dị Nso",
    "findNearbyPharmacyDesc": "Chọta ụlọ ọgwụ ndị a tụkwasịrị obi ngwa ngwa mgbe ị chọrọ ịzụrụ ọgwụ.",
    "refillReminderTitle": "Nkwado Ncheta Ịzụ Ọgwụ",
    "refillReminderDesc": "Ihe ncheta dị nwayọ ka ọgwụ gị ghara ịgwụ gị n'atụghị anya.",
    "otcWellnessTitle": "Ndụmọdụ Ahụike OTC",
    "otcWellnessDesc": "Nduzi doro anya gbasara ọgwụ ndị ị nwere ike ịzụrụ n'onwe gị n'enweghị akwụkwọ dọkịta."
  },
  "careServices": {
    "pageTitle": "Ọrụ Nlekọta",
    "pageSubtitle": "Nkwado ahụike na ọgwụgwọ e mere maka njem ahụike gị kwa ụbọchị.",
    "specialistCareTitle": "Nlekọta Ọkachamara",
    "specialistCareSubtitle": "Gwa ndị dọkịta okwu ma debanye oge na ọkachamara kwesịrị ekwesị.",
    "medicationPharmacyTitle": "Ọgwụ na Farmasi",
    "medicationPharmacySubtitle": "Nduzi ọgwụ n'asụsụ dị mfe na enyemaka ụlọ ọgwụ.",
    "wellnessSupportTitle": "Nkwado Ahụike",
    "wellnessSupportSubtitle": "Ahụike pikiche, nduzi ọgwụ nkịtị, na ụzọ doro anya maka ihe ị ga-eme ọzọ.",
    "futureWellnessTitle": "Atụmatụ Ahụike n'Ọdịnihu",
    "futureWellnessSubtitle": "Ihe na-abịa n'ọdịnihu na HealthLoop maka nchekwa ahụike.",
    "futureFeatureBadge": "Ihe Na-abịa n'Ọdịnihu",
    "futurePersonalizedMealsTitle": "Atụmatụ Nri nke Onwe",
    "futurePersonalizedMealsDesc": "Atụmatụ nri e mere maka ebumnuche gị, ihe na-ara gị ahụ, na omenala gị.",
    "futureHealthyDeliveryTitle": "Nzipụ Nri Na-edozi Ahụ",
    "futureHealthyDeliveryDesc": "Inweta nri sitere n'ụlọ nri na ndị mmekọ na-eche banyere ahụike.",
    "futureFarmFreshTitle": "Nri Ọhụrụ Sitere n'Ugbo",
    "futureFarmFreshDesc": "Ịnweta nri ọhụrụ ozugbo site n'aka ndị ọrụ ugbo nọ nso gị.",
    "futureFoodPartnershipsTitle": "Mmekọrịta Nri Ahụike",
    "futureFoodPartnershipsDesc": "Mmekọrịta na ndị na-ere nri na ụdị ahụike dị iche iche.",
    "futureNutritionCoachingTitle": "Nduzi Nri (Nutrition Coaching)",
    "futureNutritionCoachingDesc": "Nduzi onwe site n'aka ndị ọkachamara n'ihe banyere nri.",
    "futureFamilyWellnessTitle": "Atụmatụ Ahụike Ezinaụlọ",
    "futureFamilyWellnessDesc": "Atụmatụ nkwonkwo na-eme ka ezinụlọ dum nọrọ n'ụzọ ahụike.",
    "futureWellnessPlusTitle": "Ndị otu Wellness+",
    "futureWellnessPlusDesc": "Ọkwa pụrụ iche maka nduzi doro anya, nkwado kacha mkpa, na nnyocha miri emi.",
    "futurePharmacyPartnersTitle": "Mmekọrịta Farmasi",
    "futurePharmacyPartnersDesc": "Njikọ na ụlọ ọgwụ ndị a tụkwasịrị obi maka nduzi ọgwụ na ntoputa ọhụrụ.",
    "futureAdvancedSpecialistTitle": "Nlekọta Ọkachamara Dị Elu",
    "futureAdvancedSpecialistDesc": "Inweta ndị ọkachamara n'ụzọ haziri ahazi maka echiche nke abụọ na nhazi nlekọta.",
    "futureWellnessMarketplaceTitle": "Ahịa Ahụike",
    "futureWellnessMarketplaceDesc": "Ebe a haziri ahazi maka ịzụrụ ngwaahịa na ọrụ ahụike a nyocharala nke ọma.",
    "futureVendorCollabTitle": "Usoro Njikọ Ndị Na-ere Ihe",
    "futureVendorCollabDesc": "Usoro ntinye na nyocha maka ndị na-ere nri ahụike na ndị mmekọ ahụike."
  },
  "dashboardDeep": {
    "healthProfile": "Profaịlụ Ahụike",
    "notifications": "Ozi Ọkwa",
    "familyAccounts": "Akaụntụ Ezinaụlọ",
    "settings": "Nhazi",
    "logout": "Pụọ n'Akaụntụ",
    "allCaughtUp": "I mezuola ihe niile.",
    "weekInReview": "Nlebanya nke izu gị",
    "dismissNotification": "Wepụ ozi ọkwa",
    "dismissWeeklyDigest": "Wepụ nchịkọta nke izu",
    "notificationsAria": "Ozi ọkwa",
    "profileMenuAria": "Meghee menu profaịlụ",
    "loadingWellness": "Na-ebunye nchịkọta ahụike gị",
    "nextTip": "Ndụmọdụ ọzọ",
    "todayAtGlance": "Taa na nkenke",
    "healthScoreLabel": "Akara Ahụike",
    "currentStreakLabel": "Ịdị n'otu Ugbu a",
    "todaysProgress": "Ọganihu nke Taa",
    "insightForYou": "Nduzi maka gị",
    "checkMyHealthRisk": "Nyochaa ihe egwu ahụike m",
    "quickAccess": "Ịnweta Ngwa Ngwa",
    "exploreCareServicesTitle": "Chọpụta Ọrụ Nlekọta",
    "exploreCareServicesSubtitle": "Nlekọta ọkachamara · farmasi · ahụike — ihe niile n'otu ebe.",
    "familyCare": "Nlekọta Ezinaụlọ",
    "healthLibrary": "Ọba Akwụkwọ Ahụike",
    "myHealthData": "Ozi Ahụike M",
    "askQuestion": "Jụọ Ajụjụ",
    "dashLoadError": "Anyị enweghị ike ibunye dashboard gị. Biko gbalịa ọzọ.",
    "taskUpdateError": "Anyị enweghị ike imelite ọrụ a. Biko gbalịa ọzọ.",
    "perfectDay": "Ụbọchị pụrụ iche! 🎉 Ihe ngosi ịdị n'otu gị agbatịala.",
    "letsStart": "Ka anyị malite",
    "yourNextStepToday": "Ihe ọzọ ị ga-eme taa",
    "completeDailyCheck": "Mezuo nnyocha ahụike gị nke ụbọchị",
    "startDailyCheck": "Malite nnyocha nke ụbọchị",
    "viewAll": "Lee ha niile",
    "graceProtected": "E chebere gị",
    "todaysHealthRecommendations": "Ndụmọdụ Ahụike Taa",
    "updateViaCheck": "Melite site na nnyocha ụbọchị",
    "healthInsight": "Nduzi Ahụike",
    "riskCheckSubtext": "Nweta nnyocha ahụike nke onwe gị n'ime sekọnd ole na ole",
    "foodDiet": "Nri & Nri Ahụike",
    "healthScoreNew": "Akara Ahụike · Ọhụrụ",
    "letsBuildScore": "Ka anyị kpokọta akara ahụike gị ọnụ",
    "oneHealthyHabitAtATime": "Otu omume ahụike n'otu oge.",
    "nextCheck": "Nnyocha ọzọ:",
    "todayAt8pm": "taa n'elekere asatọ nke mgbede (8:00 PM)",
    "wellnessTipForYou": "Ndụmọdụ Ahụike Taa · Maka gị",
    "wellnessTipForFactor": "Ndụmọdụ Ahụike Taa · Maka {{factor}} gị",
    "logged": "E deela ya",
    "gotIt": "Aghọtala m 👍",
    "gladToSeeYou": "Obi dị anyị ụtọ ịhụ gị taa 💚",
    "takesLessThan60Sec": "Ọ naghị ewe ihe karịrị sekọnd 60",
    "scoreReadyWhenYou": "Ọ dịla njikere mgbe ọ bụla ị chọrọ",
    "scoreCompleteFirstCheck": "Mezuo nnyocha ahụike mbụ gị ka ị nweta nduzi nke onwe gị.",
    "scoreExcellent": "Kachasị Mma",
    "scoreSupportExcellent": "Ị nọ n'ọnọdụ dị mma taa. Gaa n'ihu otu a.",
    "scoreGood": "Ọ dị mma",
    "scoreSupportGood": "Ị na-agbalị. Nọgide n'omume ahụike gị.",
    "scoreModerate": "O nwere nwayọ",
    "scoreSupportModerate": "Ị na-agbalị, mana e nwere akụkụ ụfọdụ chọrọ nlebanya.",
    "scoreNeedsAttention": "Chọrọ Nlebanya",
    "scoreSupportNeedsAttention": "Ahụike gị chọrọ nlebanya taa. Obere mgbanwe ga-enyere gị aka."
  },
  "emailVerify": {
    "bannerWithEmail": "Biko gosi na email a ({{email}}) bụ nke gị ka anyị wee chebe akaụntụ gị ma na-ezitere gị ihe ncheta ụbọchị.",
    "bannerNoEmail": "Biko gosi na email gị bụ eziokwu ka anyị wee chebe akaụntụ gị ma na-ezitere gị ihe ncheta ụbọchị.",
    "sending": "Na-eziga…",
    "resend": "Zite email ọzọ",
    "sentToast": "E zigala email nkwenye. Biko lelee igbe ozi gị.",
    "sendFailToast": "Anyị enweghị ike iziga email nkwenye. Gbalịa ọzọ ma emesịa."
  },
  "forgotPassword": {
    "title": "Ị chefuru paswọọdụ gị?",
    "subtitle": "Echegbula onwe gị! Tinye email gị, anyị ga-ezitere gị ntụziaka maka otu ị ga-esi gbanwee ya.",
    "emailLabel": "Adreesị Email",
    "emailPlaceholder": "email.gi@atụmatụ.com",
    "sendResetLink": "Ziga njikọ ntọala ọhụrụ",
    "sending": "Na-eziga…",
    "backToLogin": "Laghachi na Nbanye",
    "resendLink": "Zite email ọzọ",
    "successTitle": "Lelee Email Gị",
    "successBody": "Ọ bụrụ na akaụntụ dị maka {{email}}, anyị ezitela njikọ iji gbanwee paswọọdụ gị.",
    "linkExpires": "Njikọ a ga-agwụ n'ime nkeji 30.",
    "successToast": "Lelee email gị maka ntụziaka ntọala ọhụrụ",
    "errEmptyEmail": "Biko tinye adreesị email gị",
    "errInvalidEmail": "Biko tinye email dị mma",
    "errNetwork": "Anyị enweghị ike ijikọ na saba. Lelee netwọk gị ma gbalịa ọzọ.",
    "errGeneric": "Anyị enweghị ike iziga email. Biko gbalịa ọzọ ma ọ bụ kpọtụrụ nkwado."
  },
  "resetPassword": {
    "title": "Mepụta Paswọọdụ Ọhụrụ",
    "subtitle": "Mepụta paswọọdụ siri ike maka akaụntụ gị",
    "newPasswordLabel": "Paswọọdụ Ọhụrụ",
    "newPasswordPlaceholder": "Tinye paswọọdụ ọhụrụ",
    "confirmPasswordLabel": "Kwenye Paswọọdụ",
    "confirmPasswordPlaceholder": "Tinye paswọọdụ ọzọ iji kwenye",
    "requirementsHint": "Ọ ga-abụ opekata mpe mkpụrụ akwụkwọ 8, nwee nnukwu mkpụrụ akwụkwọ, obere mkpụrụ akwụkwọ, na nọmba",
    "resetPassword": "Tọgharịa Paswọọdụ",
    "resetting": "Na-atọgharịa…",
    "successTitle": "Atọgharịla Paswọọdụ nke Ọma!",
    "successBody": "Ị nwere ike ịbanye ugbu a site na iji paswọọdụ ọhụrụ gị.",
    "successToast": "Atọgharịla paswọọdụ nke ọma!",
    "goToLogin": "Gaa na Nbanye",
    "invalidLinkTitle": "Njikọ adịghị mma",
    "invalidLinkBody": "Njikọ a adịghị mma ma ọ bụ na oge ya agwụla.",
    "requestNewLink": "Rịọ maka njikọ ọhụrụ",
    "showPassword": "Gosi paswọọdụ",
    "hidePassword": "Zụọ paswọọdụ",
    "errInvalidLink": "Njikọ adịghị mma",
    "errMismatch": "Paswọọdụ abụọ ahụ ejikọghị",
    "errTooShort": "Paswọọdụ ga-enwerịrị opekata mpe mkpụrụ akwụkwọ 8",
    "errExpiredToken": "Njikọ a agwụla oge. Biko rịọ maka nke ọhụrụ.",
    "errNetwork": "Anyị enweghị ike ijikọ na saba. Lelee netwọk gị.",
    "errGeneric": "Anyị enweghị ike itọgharị paswọọdụ gị. Biko gbalịa ọzọ."
  },
  "tips": {
    "water1": "Ịṅụ mmiri n'ime nkeji 30 mgbe i teta n'ụra nwere ike inye aka mee ka ahụ gị nwee ume.",
    "water2": "Iko mmiri tupu i rie nri ọ bụla bụ ụzọ dị mfe isi gbochie akpịrị ịkpọ nkụ.",
    "water3": "Ịgbakwunye mpekere lemon ma ọ bụ akwụkwọ mint na mmiri gị na-eme ka ọ tọọ ụtọ.",
    "meals1": "Ịgbakwunye akwụkwọ nri n'ihe ị na-eri kwa ụbọchị na-akwado ahụike afọ na obi.",
    "meals2": "Iri mkpụrụ osisi (nuts) ole na ole na nri ụtụtụ na-eme ka ume gị guzosie ike n'ụtụtụ dum.",
    "meals3": "Iri mkpụrụ osisi n'onwe ya kacha mma karịa ịṅụ mmiri mkpụrụ osisi (juice) — eriri ya na-enyere shuga ọbara gị aka.",
    "steps1": "Ịga ije nkeji iri mgbe i richara nri na-enyere ahụ gị aka ịgbari shuga nke ọma.",
    "steps2": "Ịgbatị ahụ maka nkeji ise n'ụtụtụ nwere ike iwepụ nchekasị ma mee ka ụbọchị gị malite n'udo.",
    "steps3": "Iji steepụ rịgoro elu ọbụna otu ugboro n'ụbọchị na-ewusi obi gị ike ka oge na-aga.",
    "sleep1": "Ịgbanyụ ọkụ ka ọ dị nwayọ otu awa tupu ị lakpuo na-enyere ahụ gị aka ịkwadebe maka ụra miri emi.",
    "sleep2": "Inwe otu oge ị na-eteta kwa ụbọchị — ọbụna na ngwụcha izu — na-eme ka usoro ụra gị guzosie ike.",
    "sleep3": "Inweta nkeji iri nke anwụ ụtụtụ na-enyere aka ịhazi usoro ụra gị n'ụzọ nkịtị.",
    "general1": "Ịku ume nwayọ maka nkeji abụọ nwere ike ibelata nchekasị ma mee ka uche gị guzosie ike.",
    "general2": "Cheta otu ihe i nwere ekele maka ya taa — obere mmeri nke uche na-eweta nnukwu mgbanwe.",
    "general3": "Ị bịara taa. Nke ahụ bụ omume na-eme ka omume ndị ọzọ niile dị mfe."
  },
  "factors": {
    "hydration": "ịṅụ mmiri",
    "nutrition": "nri na-edozi ahụ",
    "movement": "mmega ahụ",
    "sleep": "ụra"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "Ihe oriri ndị a tọrọ ada n'ibu",
    "prefsSaved": "A dọnyere ihe ndị ị họọrọ! Anyị na-edozi ihe oriri gị...",
    "prefsSaveFail": "Ntọala gị adọnyeghị nke ọma",
    "newOptionsFail": "Ihe oriri ọhụrụ ndị a tọrọ ada n'ibu",
    "invalidZip": "Biko tinye nọmba ZIP nke ruru mkpụrụ ise",
    "noVendorsArea": "O nweghị ndị na-ere nri nọ nso ebe a ugbu a. Anyị ka na-agbasa ozi anyị!",
    "vendorsFetchFail": "Anyị enweghị ike ịchọta ndị na-ere nri",
    "selectVendorFirst": "Biko buru ụzọ họrọ onye ga-eweta nri ahụ",
    "removedFromCart": "E wepụla ya n'akpa nri gị",
    "orderPlaced": "Ị zụtaala nri a nke ọma! 🎉",
    "enterZipFirst": "Biko buru ụzọ tinye nọmba ZIP gị n'ebe nnyefe nri",
    "mealNotAvailable": "Nri a adịbeghị maka nnyefe n'ógbè gị ugbu a",
    "mealUnavailable": "Nri a adịghị n'aka ndị na-ere nri nọ gị nso ugbu a",
    "vendorOptionsFail": "Ihe ndị onye na-ere nri nwere tọrọ ada n'ibu",
    "favoriteSaveFail": "Ihe a ị hụrụ n'anya adọnyeghị nke ọma",
    "removedFromFavorites": "E wepụla ya n'ihe ndị ị hụrụ n'anya",
    "favoriteRemoveFail": "E wepụghị ihe a ị hụrụ n'anya nke ọma",
    "cartEmpty": "Akpa nri gị tọgbọ chakoo",
    "noMealOptions": "O nweghị ihe oriri ọ bụla dị",
    "loadingOptions": "Anyị na-achọpụta ihe oriri ndị dị...",
    "selectPreferences": "Họrọ Ihe Ndị Ị Na-enwe mmasị Iri",
    "mealBuilder": "Onye Nhazi Nri",
    "myFavorites": "Ihe Ndị M Hụrụ n'Anya",
    "myFavoriteMeals": "Nri Ndị M Kasị Hụ n'Anya",
    "noFavoritesYet": "I nwebeghị nri ọ bụla ị hụrụ n'anya!",
    "price": "Ọnụ ego",
    "delivery": "Nnyefe Nri",
    "deliveryFee": "Ego Nnyefe",
    "distance": "Ebe ọ nọ",
    "subtotal": "Ngụkọta nwa oge",
    "total": "Ngụkọta niile",
    "orderNumber": "Nọmba Ihe Ị Zụrụ",
    "vendor": "Onye Na-ere Nri",
    "totalAmount": "Ego Niile",
    "estimatedDelivery": "Oge a tụrụ anya nnyefe",
    "whyThisMeal": "Gịnị kpatara nri a",
    "selectThisMeal": "Họrọ Nri A",
    "swapMeal": "Gbanwee Nri",
    "orderThisMeal": "Zụta Nri A",
    "notAvailableNearYou": "Ọ dịghị nso n'ebe ị nọ",
    "tryAdjustingPrefs": "Nwaa ịgbanwe ihe ndị ị họrọ maka nri ka ị hụ aro ndị ọzọ",
    "myMealPlanSummary": "Nchịkọta Nhazi Nri m",
    "saveCompletePlan": "Dọnye Nhazi Niile",
    "yourFoodPreferences": "Ihe Ndị Ị Na-ahọrọ n'Iri Nri",
    "editPreferences": "Dezie Ihe Ndị Ị Họọrọ",
    "healthyMealDelivery": "Nnyefe Nri Na-enye Ahụ Ike",
    "enableDelivery": "Gbanwee Nnyefe",
    "enterZipCode": "Tinye Postcode / ZIP gị ka ị hụ nri ndị dị",
    "enterPostcode": "Tinye Postcode / ZIP Code gị",
    "postcodePlaceholder": "dịka, MK10 9XX ma ọ bụ 10001",
    "postcodePartialHint": "Biko tinye postcode gị niile ka anyị nwee ike ịchọtara gị nri dị nso n'ụzọ ziri ezi.",
    "noLocalPartnersFallback": "Anyị ahụbeghị ndị mmekọ nọ nso ebe a. Kama, lee aro maka ihe ndị e ji esi nri n'ógbè gị.",
    "noLivePartnersFallback": "O nwebeghị ndị mmekọ HealthLoop na-ere nri nọ nso n'ógbè gị ugbu a.",
    "culturalNutritionTitle": "Nchọpụta Ahụ Ike n'Ógbè Gị",
    "culturalNutritionSubtitle": "Ntuziaka maka ibi ndụ dị mma — nke metụtara omenala gị, na-enye ozi, ma kwekọọ n'ógbè gị.",
    "viewIngredientGuidance": "Lee Ntuziaka",
    "popularWellnessTitle": "Nri Ahụ Ike Ndị Mmadụ Na-erikarị nso ebe a",
    "popularWellnessIntro": "Ihe ndị e ji esi nri dị n'omenala gị na ebe ndị mmadụ na-aga ịchọ nri ahụ ike n'ógbè gị.",
    "subsectionPopularFoodsTitle": "Nri Maka Ahụ Ike Kwa Ụbọchị",
    "subsectionCulturalIngredientsTitle": "Aro Maka Ihe E Ji Esi Nri n'Omenala",
    "subsectionHealthySwapsTitle": "Echiche Maka Mgbanwe Nri Ka Mma",
    "subsectionLocalEnvironmentTitle": "Ebe Ahụ Ike Dị n'Ógbè Gị",
    "subsectionLocalEnvironmentIntro": "Ebe ndị mmadụ nọ n'ógbè gị na-enwetakarị nri ndị na-edozi ahụ.",
    "findLocalTitle": "Ebe Ndị Nwere Nri Ahụ Ike",
    "findLocalSubtitle": "Chọpụta ndị na-ere nri, ụlọ ahịa, na ihe e ji esi nri dị mma n'ógbè gị.",
    "findOptions": "Chọọ Nhọrọ Ndị Dị",
    "searching": "Anyị na-achọ ya…",
    "nearbyVendorsFound": "Achọtara ebe {{count}} nwere nri ahụ ike nso ebe a",
    "orderHintEnabled": "Pịa \"Zụta Nri A\" na kaadị nri ọ bụla dị n'okpuru ka ị hụ ego ole ọ bụ.",
    "orderHintDisabled": "Gbanwee \"Nnyefe\" n'elu ka ị nwee ike zụta nri ndị a ozugbo site na kaadị nri ha.",
    "localIngredientTitle": "Ihe E Ji Esi Nri Dị n'Ógbè Gị",
    "localIngredientIntro": "Ihe ndị a ma ama n'omenala anyị na ebe ị ga-enweta ha nso ebe a.",
    "lookFor": "Chọọ maka",
    "noVendorsFallback": "O nwebeghị ndị na-ere nri n'ebe a — mana ntuziaka maka ihe e ji esi nri dị n'elu ka na-arụ ọrụ n'ụlọ ahịa ọ bụla ma ọ bụ n'ahịa.",
    "showingMealsFrom": "Anyị na-egosi nri sitere na",
    "sectionSnapshot": "Nchịkọta Nri nke Taa",
    "sectionSnapshotSubtitle": "Nlele anya ngwa ngwa maka mmiri ị ṅụrụ, calorie, na otu nri gị siri kwekọọ maka taa.",
    "snapshotHydration": "Mmiri Ị Ṅụrụ",
    "snapshotHydrationHint": "Gbalịa ka ị ṅụọ iko mmiri 6–8 taa.",
    "snapshotCalories": "Calorie",
    "snapshotCaloriesHint": "Ịgụ calorie na-abịa n'oge na-adịghị anya.",
    "snapshotBalance": "Nha Nri",
    "mealsLogged": "nri a họọrọ",
    "snapshotTip": "Ndụmọdụ Ahụ Ike",
    "snapshotTipHint": "Tụkwasị akwụkwọ nri ọzọ n'ihe oriri gị ọzọ.",
    "sectionRecommendations": "Aro Ndị Maara Ihe",
    "sectionRecommendationsSubtitle": "Ntuziaka ihe e ji esi nri dị n'omenala na echiche maka mgbanwe nri dị mma.",
    "sectionGoals": "Ebumnuche Nri",
    "sectionGoalsSubtitle": "Leba anya n'ihe ndị dị mkpa n'ahụ ike gị.",
    "goalWeight": "Nkwado Maka Ibu Arọ",
    "goalWeightDesc": "Nri emebere maka idobe ibu arọ gị nke ọma.",
    "goalEnergy": "Nkwado Maka Ike",
    "goalEnergyDesc": "Nri ga-enye gị ike maka ọrụ ụbọchị niile.",
    "goalImmunity": "Nkwado Maka Mgbochi Ọrịa",
    "goalImmunityDesc": "Nri ndị nwere antioxidant iji nyere gị aka iguzogide ọrịa.",
    "goalFamily": "Nri Ezinụlọ",
    "goalFamilyDesc": "Nhọrọ maka ụmụaka na ndị nne na-atụ anya dị n'ime ya.",
    "sectionGuidance": "Ntuziaka Nri",
    "sectionGuidanceSubtitle": "Echiche maka nri ụtụtụ, ehihie, abalị, na ihe mmechi ọnụ ị nwere ike ịgbanwe otu masịrị gị.",
    "futureNutritionTitle": "Nkwado Nri n'Ọdịnihu",
    "futureNutritionBody": "Ntuziaka nri ahụ ike, mmekọrịta maka nri dị mma, na nkwado nri ezinụlọ ga-abịa na HealthLoop n'oge na-adịghị anya.",
    "comingSoon": "Na-abịa N'oge Na-adịghị Anya",
    "coverageLocalStores": "Ụlọ ahịa nri ahụ ike dị nso",
    "coverageLocalFarms": "Ubi nri ndị dị nso",
    "coverageCertifiedVendors": "Ndị na-ere nri agbaara àmà",
    "coverageFreshProduce": "Nri a ka ghọtara ọhụrụ",
    "medWellnessFutureTitle": "Nkwado Ọgwụ na Ahụ Ike",
    "medWellnessFutureDesc": "Ijikọ nhazi nri gị na ntuziaka gbasara ọgwụ ị na-aṅụ. Ị ga-ahụ ya n'ebe Nkwado na Enyemaka.",
    "pharmacyAssistFutureTitle": "Enyemaka Ụlọ Ọgwụ",
    "pharmacyAssistFutureDesc": "Chọta ụlọ ọgwụ ndị dị nso ma nwee ihe ncheta maka ịṅụ ọgwụ n'akụkụ nri gị. Ị ga-ahụ ya n'ebe Nkwado na Enyemaka.",
    "savePreferences": "Dọnye Ihe Ndị Ị Họọrọ",
    "quickAccessSavedMeals": "Ịhụ nri gị dọnyere ngwa ngwa",
    "saveMealsFromBuilder": "Dọnye nri ndị ị nwetara n'ebe Nhazi Nri",
    "chooseVendor": "Họrọ onye na-ere nri ị ga-azụta nri a n'aka ya",
    "yourCart": "Akpa Nri Gị",
    "addMealsToStart": "Tinyere nri site na nhọrọ ndị dị n'okpuru ka ị malite",
    "orderPlacedDesc": "Ị zụtaala nri ahụ ike gị nke ọma",
    "continueShopping": "Gaa n'ihu ịzụ ihe",
    "trackOrder": "Leba anya n'ebe nri gị ruru",
    "healthyStoresTitle": "Ụlọ Ahịa Ahụike na Ahịa Wellness Dị nso",
    "healthyStoresIntro": "Ụdị ụlọ ahịa na-anabata omenala dị iche iche ị ga-achọ n'ógbè gị — maka echiche, ọ bụghị maka nnyefe.",
    "healthyStoresGuidanceTitle": "Ntuziaka ịzụ ahịa ahụike",
    "healthyStoresDisclaimer": "HealthLoop na-ekerịta naanị echiche maka ịdị mma na ịzụ ahịa ahụike — ọ bụghị ntuziaka ọgwụgwọ ma ọ bụ nri pụrụ iche.",
    "healthyStores": {
      "organic": {
        "type": "Ụlọ ahịa nri organic",
        "description": "Nri ọhụrụ, nke na-enweghị ọgwụ ahụhụ na nri ndị a na-emebighị emebi.",
        "tags": [
          "Nri zuru oke",
          "Ihe ubi ọhụrụ"
        ]
      },
      "farmers": {
        "type": "Ahịa ndị ọrụ ugbo",
        "description": "Mkpụrụ osisi, akwụkwọ nri, na ihe ubi ọdịnala si n'aka ndị kụrụ ha.",
        "tags": [
          "Nke mpaghara",
          "Nke oge ya"
        ]
      },
      "african": {
        "type": "Ụlọ ahịa nri Afrịka ọhụrụ",
        "description": "Ji, unere, akwụkwọ nri, nri nkwụ na nri ndị ọzọ sitere na West na East Africa.",
        "tags": [
          "Omenala",
          "Ihe ubi ọhụrụ"
        ]
      },
      "caribbean": {
        "type": "Ahịa nri Caribbean",
        "description": "Callaloo, akpụ, ose scotch bonnet, ackee, na nri ndị ọzọ sitere na agwaetiti.",
        "tags": [
          "Omenala",
          "Nri zuru oke"
        ]
      },
      "asian": {
        "type": "Nnukwu ahịa akwụkwọ nri Eshia",
        "description": "Bok choy, daikon, lotus root, tofu, na nri ndị ọzọ sitere na kọntinent Eshia.",
        "tags": [
          "Omenala",
          "Ihe ubi ọhụrụ"
        ]
      },
      "halal": {
        "type": "Ahịa nri ahụike Halal",
        "description": "Anụ ndị nwere asambodo Halal, ihe ubi ọhụrụ na ngwa nri ọdịnala.",
        "tags": [
          "Halal",
          "Omenala"
        ]
      },
      "mediterranean": {
        "type": "Ahịa nri Mediterranean",
        "description": "Mmanụ olive, agwa, akwụkwọ nri ọhụrụ, na nri zuru oke sitere na Mediterranean.",
        "tags": [
          "Omenala",
          "Nri zuru oke"
        ]
      },
      "wellness": {
        "type": "Ụlọ ahịa nri lekwasịrị anya na wellness",
        "description": "Nri zuru oke, nhọrọ nri sitere na osisi na ihe ndị dị mma maka ahụike.",
        "tags": [
          "Nri zuru oke",
          "Nri osisi"
        ]
      }
    },
    "healthyShoppingTips": [
      "Mmalite ịzụ ahịa n'akụkụ ụlọ ahịa — ihe ubi ọhụrụ na anụ na-enweghị abụba na-anọkarị n'akụkụ ahụ.",
      "Họrọ nri zuru oke nwere naanị otu ihe karịa nri ndị a nụchara anụcha.",
      "Họrọ ihe ubi nke oge ya n'ógbè gị — ọ na-akacha ọhụrụ, dị ọnụ ala, ma nwee ezigbo nri n'ime ya.",
      "Jụọ ndị na-ere ahịa ebe nri siri bịa na otu esi kụọ ya — ọtụtụ ga-enwe obi ụtọ ịgwa gị."
    ]
  },
  "messages": {
    "success": "O mere nke ọma!",
    "error": "Nsogbu adịla",
    "saved": "Adọnyere ya nke ọma",
    "updated": "Emegharịrị ya nke ọma",
    "deleted": "Ehichapụrụ ya nke ọma",
    "confirmDelete": "Ị doro anya na ị chọrọ ihichapụ ihe a?",
    "networkError": "Nsogbu netwọk. Biko nwaa ọzọ.",
    "somethingWrong": "O nwere ihe mehiere",
    "failedToLoad": "Ihe ndị dị n'ihu ihuenyo tọrọ ada n'ibu",
    "offlineMode": "I nweghị netwọk - anyị na-egosi naanị ihe ndị dị n'ime ekwentị gị",
    "locationDenied": "Ajụrụ ịhụ ebe ị nọ. Lelee ntọala ihe nchọgharị gị ka ị gbanwee ya.",
    "locationUnavailable": "Ozi banyere ebe ị nọ adịghị",
    "locationTimeout": "Oge ịchọ ebe ị nọ agwụla. Biko nwaa ọzọ.",
    "locationError": "Anyị enweghị ike ịhụ ebe ị nọ",
    "locationGranted": "Anyị nwere ike ịhụ ebe ị nọ ugbu a! Na-egosi ihe ndị dị nso n'ebe ị nọ",
    "locationNotSupported": "Ihe nchọgharị gị anaghị akwado ịchọ ebe ị nọ",
    "requestingLocation": "Anyị na-arịọ ka anyị hụ ebe ị nọ..."
  },
  "trust": {
    "medicalDisclaimer": "Ihe Nkwupụta",
    "privacySecure": "Ozi gị ezochiri ma nwee nchebe",
    "dataEncrypted": "Ozi gị niile nwere nchebe ma bụrụ ihe nzuzo",
    "notMedicalAdvice": "Nke a abụghị ndụmọdụ ụlọ ọgwụ",
    "consultProvider": "Na-agba ndị na-ahụ maka ahụ ike gị ajụjụ mgbe niile",
    "evidenceBased": "Ntuziaka dabeere n'eziokwu sayensị",
    "generalEducation": "Mmụta ahụ ike n'ozuzu",
    "preventiveGuidance": "Ntuziaka mgbochi ọrịa",
    "lifestyleSupport": "Maka mmata na nkwado ibi ndụ",
    "lastUpdated": "Oge ikpeazụ e megharịrị ya",
    "expertReviewed": "Ndị ọkachamara nyochara ya",
    "aiGenerated": "Ozi sitere na AI",
    "disclaimerShort": "HealthLoop na-enye mmụta ahụ ike, ọ bụghị onye nnọchiteanya maka ndụmọdụ dọkịta.",
    "disclaimerFull": "HealthLoop na-akwado ahụ ike na mmata mbụ. Anyị na-enye mmụta ahụ ike, nleba anya n'omume, na nghọta maka ahụ ike. Nke a abụghị onye nnọchiteanya maka nlekọta ụlọ ọgwụ. Na-agba ndị dọkịta gị ajụjụ mgbe niile maka ndụmọdụ, nchọpụta ọrịa, ma ọ bụ ọgwụgwọ.",
    "trustBanner": {
      "title": "HealthLoop nọ ebe a iji kwado njem ahụ ike gị",
      "description": "Anyị na-enye mmụta ahụ ike na ntuziaka mgbochi dabeere n'ebe ndị a tụkwasịrị obi. Nke a abụghị ndụmọdụ dọkịta. Na-agba ndị ọkachamara ahụ ike ajụjụ mgbe niile maka mkpebi gbasara ahụ ike gị."
    }
  },
  "health": {
    "preventiveHealth": "Ihe Nlebanya Ahụ Ike",
    "educationHub": "Ebe Mmụta",
    "engagementWidget": "Ihe Ngosi Mmegharị",
    "wellnessCheckIn": "Nleba anya Ahụ Ike",
    "todaysMetrics": "Ihe Atụmatụ Taa",
    "bloodPressure": "Ọbara Mgbali Elu",
    "heartRate": "Otú Obi Si Akụ",
    "weight": "Ibu Arọ",
    "sleep": "Ụra",
    "waterIntake": "Mmiri Ị Ṅụrụ",
    "exercise": "Mmegbu Ahụ",
    "logMetric": "Dọnye Ozi Ahụ Ike",
    "viewHistory": "Lee Ihe Mere n'Oge Gara Aga"
  },
  "aiInsights": {
    "title": "Nghọta Ahụ Ike sitere na AI",
    "comingSoon": "Ozi gị na-achịkọta",
    "comingSoonDesc": "Mechaa nleba anya otu ụbọchị ma ọ bụ abụọ, anyị ga-enye gị nghọta gbasara gị ebe a.",
    "learnMore": "Mụtakwuo ihe",
    "evidenceSources": {
      "WHO": "Dabeere na ntuziaka WHO",
      "NHS": "Kwekọrọ na aro NHS",
      "CDC": "Nke ntuziaka CDC kwadoro",
      "RESEARCH": "Dabeere na nchọpụta sayensị",
      "CLINICAL": "Nke nnyocha ụlọ ọgwụ kwadoro"
    }
  },
  "dailyInsight": {
    "title": "Nghọta Ahụ Ike nke Taa",
    "gettingStarted": "Ịmalite",
    "focus": "Ihe lekwasịrị anya",
    "quickInsight": "Nghọta Ngwa Ngwa",
    "simpleExplanation": "Nkọwa Dị Mfe",
    "realLifeImpact": "Uru Ọ Bara na Ndụ",
    "yourActionStep": "Ihe Ị Ga-eme",
    "basedOnYour": "Dabeere na",
    "personalizedFor": "Nke a bụ maka gị dabeere na ozi ahụ ike gị n'oge na-adịbeghị anya",
    "getNewInsight": "Nweta nghọta ọhụrụ",
    "newInsightLoaded": "Nghọta ọhụrụ abịala! 💡",
    "failedToRefresh": "Nghọta ọhụrụ ahụ tọrọ ada",
    "priority": {
      "high": "Ka Anyị Lekwasị Anya Ebe A",
      "medium": "Ihe Kwesịrị Ntụle"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "O nweghị ozi mkpọtụ ahụ ike ugbu a",
    "noAlertsDesc": "Ị na-edebe omume ọma maka ahụ ike. Gaa n'ihu!",
    "whatYouCanDo": "Ihe ị nwere ike ime:",
    "viewMealSuggestions": "Lee Aro Maka Nri Gị"
  },
  "engagement": {
    "currentStreak": "Ụbọchị Ole Ị Na-aga n'Ihu",
    "bestStreak": "Ụbọchị Kasị Mma Ị Gara n'Ihu",
    "thisWeek": "Izu a",
    "exerciseDays": "Ụbọchị Mmegbu Ahụ",
    "hydrationDays": "Ụbọchị Ịṅụ Mmiri",
    "healthMetricsLogged": "Ozi Ahụ Ike Ndị E Dọnyere",
    "weeklyGoalsProgress": "Otu Ị Na-esi Emezu Ebumnuche Izu a",
    "completed": "emechara",
    "days": "ụbọchị",
    "keepGoing": "Gaa n'ihu!",
    "personalRecord": "Ihe kacha mma ị meworo!",
    "goalMet": "Emezula ebumnuche!"
  },
  "reminders": {
    "title": "Ihe Ncheta Ahụ Ike",
    "subtitle": "Nọgide n'ụzọ ziri ezi site na ozi ncheta maka ahụ ike",
    "breakfast": "Ncheta Nri Ụtụtụ",
    "lunch": "Ncheta Nri Ehihie",
    "dinner": "Ncheta Nri Abalị",
    "water": "Mmiri Ị Ṅụrụ",
    "movement": "Oge Mmegharị Ahụ",
    "sleep": "Ncheta Ụra",
    "wellness": "Nleba anya Ahụ Ike",
    "healthLogging": "Idọnye Ozi Ahụ Ike",
    "annualCheckup": "Nleba anya nke Afọ",
    "enable": "Gbanwunye",
    "disable": "Gbanwụọ",
    "customize": "Hazie Oge",
    "stayConsistent": "Nọgide n'Omume Ọma na Ihe Ncheta Ndị A",
    "setupFriendly": "Hazie ihe ncheta ga-enyere gị aka iwulite omume ọma maka ahụ ike.",
    "customizeWhen": "Ị nwere ike ịhazi oge na ugboro ole ị ga-enweta ihe ncheta ọ bụla.",
    "supportive": "Atụla egwu - anyị ga-eme ka ha dị nwayọ ma nyere gị aka! 💚",
    "noPreferences": "Ahụbeghị Ihe Ncheta Ị Họọrọ",
    "noPreferencesDesc": "Anyị enweghị ike iweta ntọala ncheta gị. Ọ nwere ike ịbụ na nke a bụ nke mbụ gị, ma ọ bụ na o nwere nsogbu n'iweta ihe ị họọrọ.",
    "retryLoading": "Nwaa Iweta Ya Ọzọ",
    "saveSettings": "Dọnye Ntọala",
    "saving": "Na-adọnye ya..."
  },
  "empty": {
    "startJourney": "Malite Njem Ahụ Ike Gị",
    "startJourneyDesc": "Malite njem ahụ ike gị taa! Gwa anyị otú ọ dị gị ka i wee nweta nghọta maka gị na nleba anya n'ahụ ike gị n'oge niile.",
    "completeFirstCheckIn": "Mechaa Nleba anya Mbụ",
    "stayOnTrack": "Nọgide n'Ụzọ Ziri Ezi",
    "stayOnTrackDesc": "Nọgide n'usoro gị kwa ụbọchị 💊 Tinyere ọgwụ gị ka ị na-enweta ihe ncheta na nkwado.",
    "addFirstMedication": "Tinyere Ọgwụ Mbụ",
    "learnMedicationSafety": "Mụta Maka Nchebe Ọgwụ",
    "buildMealLibrary": "Wulite Nchịkọta Nri Gị",
    "buildMealLibraryDesc": "O nwebeghị nri ị hụrụ n'anya. Dọnye nri ndị na-atọ gị ụtọ maka nleba anya ngwa ngwa na nhazi nri dị mfe.",
    "exploreMealOptions": "Chọpụta Ihe Oriri Ndị Dị",
    "insightsAwait": "Nghọta Gị Na-eche Gị",
    "insightsAwaitDesc": "Mechaa nleba anya kwa ụbọchị ka i wee nweta nghọta banyere ahụ ike gị na nyocha nke omume gị.",
    "startDailyCheckIn": "Malite Nleba anya nke Ụbọchị",
    "learnAboutInsights": "Mụta Maka Nghọta Anyị Na-enye",
    "buildingStory": "Iwulite Akụkọ Ahụ Ike Gị",
    "buildingStoryDesc": "O nwebeghị ozi gara aga. Otu ahụ ike gị si aga ga-apụta ebe a ka ị na-emecha nleba anya kwa ụbọchị.",
    "completeCheckIn": "Mechaa Nleba anya",
    "tipComplete7Days": "Ndụmọdụ: Mechaa nleba anya ruo ụbọchị asaa ka ị hụ otú ahụ ike gị si aga n'ezie.",
    "startTrackingHabits": "Malite Ilekọta Omume Ahụ Ike",
    "startTrackingHabitsDesc": "O nwebeghị omume a na-elekọta. Obere ihe ị na-eme kwa ụbọchị na-eweta mgbanwe ahụ ike na-adịte aka.",
    "trackFirstHabit": "Leba anya n'Omume Mbụ",
    "getMoving": "Mee Mmegharị Ahụ",
    "getMovingDesc": "O nwebeghị mmegharị ahụ e dere ebe a. Ma ọ bụrụ naanị nkeji iri, ọ pụrụ inye gị obi ụtọ na ike.",
    "logActivity": "Dọnye Mmegharị Ahụ",
    "allCaughtUp": "Ihe Niile Dị Mma!",
    "allCaughtUpDesc": "I nweghị ozi ọhụrụ. Laghachi azụ ma emechaa maka ozi ndị ọzọ na ihe ncheta ahụ ike.",
    "noResultsFound": "Ahụbeghị Ihe Ị Na-achọ",
    "noResultsFoundDesc": "Anyị ahụghị ihe ọ bụla gbasara \"{query}\". Nwaa ịchọ ihe ọzọ ma ọ bụ lee nhọrọ ndị ọzọ."
  },
  "footer": {
    "tagline": "Onye Enyi Gị n'Ilekọta Ahụ Ike Site n'Ike AI",
    "builtWith": "Ejiri nlezianya wee rụọ ya maka njem ahụ ike gị",
    "allRightsReserved": "Ikike niile nọ n'aka anyị.",
    "about": "Maka Anyị",
    "privacy": "Nzuzo",
    "terms": "Usoro na Iwu",
    "contact": "Kpọtụrụ Anyị",
    "helpCenter": "Ebe Nnyemaka"
  },
  "modals": {
    "feedback": {
      "title": "Kọọrọ Anyị Echiche Gị",
      "subtitle": "Nyere anyị aka ime ka HealthLoop dịkwuo mma",
      "whatWorking": "Gịnị na-arụ ọrụ nke ọma?",
      "whatImprove": "Gịnị ka anyị nwere ike imezigharị?",
      "placeholder": "Kọọrọ anyị echiche gị...",
      "thankYou": "Daalụ maka echiche gị!",
      "submitted": "Echiche gị na-enyere anyị aka ime ka HealthLoop ka mma."
    },
    "reportProblem": {
      "title": "Kọọ maka Nsogbu",
      "subtitle": "Nyere anyị aka idozi mmejọ ma mezie ngwa a",
      "describe": "Kọwaa nsogbu ahụ",
      "placeholder": "Gịnị merenụ? Biko kọwaa ya nke ọma...",
      "optional": "Nhọrọ: Usoro i siri hụ nsogbu ahụ",
      "stepsPlaceholder": "1. Apịrị m...\n2. Emesia m...",
      "thankYou": "Daalụ maka ịkọrọ anyị!",
      "submitted": "Anyị ga-eleba anya na nke a ozugbo."
    },
    "mealPreferences": {
      "title": "Họrọ Ụdị Nri Gị",
      "subtitle": "Gwa anyị gbasara ụdị nri ndị na-amasị gị",
      "cuisines": "Ụdị Nri Obodo Ndị Masịrị Gị",
      "selectCuisines": "Họrọ ndị niile masịrị gị",
      "dietary": "Nhọrọ Nri n'ihi Ahụ Ike",
      "selectDietary": "Họrọ ihe ndị ahụ gị chọrọ",
      "allergies": "Ihe Ndị Na-anaghị Amasị Ahụ Gị (Allergies)",
      "allergiesPlaceholder": "Dịka: Aki, Azụ, Ihe nwere Gluten",
      "save": "Chekwaa Nhọrọ Gị",
      "saving": "Na-echekwa..."
    },
    "upgrade": {
      "title": "Gbagoo na Premium",
      "subtitle": "Mepee ohere maka atụmatụ niile",
      "features": "Atụmatụ Premium",
      "getStarted": "Malite Ugbu a",
      "learnMore": "Mụtakwuo Ihe"
    }
  },
  "login": {
    "title": "Usoro Gị Maka Nduzi Ahụ Ike",
    "subtitle": "Soro usoro ahụ gị, mụta ihe, ma mee ihe tupu nsogbu abịa. Ejiri ya maka mgbochi ọrịa, agụmakwụkwọ, na ọdịmma ahụ ike.",
    "email": "Email",
    "password": "Password",
    "signIn": "Banye",
    "signingIn": "Na-abanye...",
    "forgotPassword": "Ị chefuru Password gị?",
    "noAccount": "Ị nweghị akaụntụ?",
    "createAccount": "Mepụta otu",
    "biometricLogin": "Jiri Biometrics banye",
    "biometricHelper": "Jiri mkpịsị aka, ihu (Face ID), ma ọ bụ Windows Hello",
    "authenticating": "Na-enyocha...",
    "vendorPartner": "Ị bụ onye mmekọ (vendor)?",
    "vendorLogin": "Ntinye Ndị Vendor",
    "emailRequired": "Biko tinye email gị ụzọ",
    "biometricSuccess": "I banyela nke ọma site na biometrics! 🎉",
    "noPasskeys": "Enweghị biometric e debere. Biko jiri password banye na mbụ.",
    "biometricCancelled": "Akagbuola ntinye biometric",
    "biometricFailed": "Ntinye biometric adaghị. Biko jiri password ganye."
  },
  "register": {
    "title": "Soro HealthLoop",
    "subtitle": "Malite njem mgbochi ọrịa gị taa",
    "fullName": "Aha Gị n'uju",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Kwenye Password",
    "createAccount": "Mepụta Akaụntụ",
    "haveAccount": "Ị nwere akaụntụ ugbua?",
    "signIn": "Banye",
    "creating": "Na-emepụta akaụntụ...",
    "passwordTooShort": "Password ga-enwerịrị opekata mpe mkpụrụokwu 8",
    "setupBiometric": "Dobe Ntinye Biometric",
    "setupBiometricDesc": "Jiri mkpịsị aka gị ma ọ bụ ihu gị banye ngwa ngwa na n'enweghị nsogbu",
    "setupNow": "Dobe Biometric Ugbu a",
    "skipForNow": "Hapụ ya ugbua",
    "settingUp": "Na-edobe ya...",
    "benefit1": "Ị gaghị na-echeta password oge niile",
    "benefit2": "Ọ kacha nwee nchekwa",
    "benefit3": "Banye site na naanị otu mmetụ ma ọ bụ ile anya",
    "biometricPrivacy": "Ihe ọmụma biometrics gị anaghị apụ na fon gị",
    "biometricSuccess": "Edobela ntinye biometric nke ọma! 🎉",
    "biometricFailed": "Edobereghị biometrics. Ị nwere ike ime ya emechaa na settings.",
    "biometricSetupLater": "Ị nwere ike idobe ntinye biometric emechaa na profaịlụ gị"
  },
  "womensHealthPage": {
    "title": "Ihe Nleba Ahụ Ike Ụmụ Nwaanyị",
    "subtitle": "Soro oge ịhụ nsọ gị, mgbaàmà, na ọdịmma gị",
    "cycleOverview": "Nlele Usoro Ịhụ Nsọ",
    "currentPhase": "Ebe Ị Nọ Ugbu a",
    "nextPeriod": "Oge Nsọ Ọzọ A Na-atụ Anya",
    "logPeriod": "Tee Akara Nsọ Gị",
    "logSymptoms": "Tee Akara Mgbaàmà",
    "insights": "Ihe Ị Kwesịrị Ịma",
    "tips": "Ndụmọdụ Maka Oge Gị",
    "history": "Akụkọ banyere Nsọ Gị",
    "noData": "Enweghị ozi ugbua",
    "noDataDesc": "Malite idepụta oge nsọ gị ka i wee nweta ndụmọdụ ga-enyere gị aka.",
    "startTracking": "Malite nleba anya"
  },
  "notifications": {
    "title": "Ozi Ndị Batara",
    "markAllRead": "Gosi na agụọla ha niile",
    "noNotifications": "Enweghị ozi ọhụrụ",
    "viewAll": "Lee Ha Niile"
  },
  "familyHealth": {
    "title": "Ahụ Ike Ezinụlọ na Ụmụaka",
    "subtitle": "Nkwado maka mgbochi ọrịa n'ezinụlọ gị niile",
    "tabImmunizations": "Ọgwụ Mgbochi",
    "tabEducation": "Mmụta",
    "tabReminders": "Ihe Ncheta",
    "tabPlanner": "Atụmatụ Ezinụlọ",
    "immunizations": {
      "title": "Mmụta maka Ọgwụ Mgbochi",
      "subtitle": "Mara maka ọgwụ mgbochi dị mkpa",
      "recommendedSchedule": "Oge Atụmatụ Ọgwụ",
      "byAge": "Dịka Afọ Si Dị",
      "infants": "Ụmụ Ọhụrụ (ọnwa 0-12)",
      "toddlers": "Ụmụaka (afọ 1-3)",
      "preschool": "Ndị Ụlọ Akwụkwọ Ọtaakara (afọ 4-6)",
      "schoolAge": "Ndị Ụlọ Akwụkwọ Praịmarị (afọ 7-12)",
      "teens": "Ụmụaka Nọ n'Eto (afọ 13-18)",
      "adults": "Ndị Kenke",
      "learnMore": "Mụtakwuo Ihe",
      "consultDoctor": "Gwa onye ọkachamara ahụ ike gị oge niile maka ndụmọdụ ọgwụ mgbochi gị",
      "upcomingReminders": "Ihe Ncheta Ọgwụ Ndị Na-abịa",
      "noReminders": "Enweghị ncheta ọgwụ mgbochi ọ bụla",
      "addReminder": "Tinye Ihe Ncheta Ọgwụ",
      "reminderFor": "Ihe ncheta maka",
      "dueDate": "Ụbọchị Ọ ga-abụ",
      "notes": "Ihe Akara",
      "markComplete": "Gosi na Emechara Ya"
    },
    "education": {
      "title": "Mmụta Ahụ Ike Ezinụlọ",
      "subtitle": "Ihe ọmụma doro anya maka mgbochi ọrịa",
      "categories": "Ụdị Dị Iche Iche",
      "infant": "Nlekọta Nwa Ọhụrụ",
      "child": "Ntolite Nwa",
      "nutrition": "Nri na Ntolite",
      "safety": "Nchebe na Mgbochi",
      "mental": "Ahụ Ike uche",
      "hygiene": "Ịdị Ọcha na Àgwà Ọma",
      "searchPlaceholder": "Chọọ ihe gbasara ahụ ike...",
      "popularTopics": "Isiokwu Ndị A Ma ama",
      "readMore": "Gụkwuo Ihe",
      "readTime": "nkeji ọgụgụ"
    },
    "reminders": {
      "title": "Ihe Ncheta Ahụ Ike Ezinụlọ",
      "subtitle": "Soro usoro nlekọta mgbochi ọrịa nke ezinụlọ gị niile",
      "createReminder": "Mepụta Ihe Ncheta",
      "familyMember": "Onye Ezinụlọ",
      "reminderType": "Ụdị Ncheta",
      "frequency": "Ugboro Ole",
      "activeReminders": "Ncheta Ndị Na-arụ Ọrụ",
      "upcomingThisWeek": "Ndị Na-abịa n'Izu a",
      "noActiveReminders": "Enweghị ncheta na-arụ ọrụ ugbua",
      "types": {
        "checkup": "Nnyocha Ahụ Ike",
        "dental": "Nleta Eze",
        "vision": "Nnyocha Anya",
        "vaccine": "Ịgba Ọgwụ Mgbochi",
        "medication": "Ịṅụ Ọgwụ",
        "custom": "Nke Gị Onwe Gị"
      }
    },
    "planner": {
      "title": "Atụmatụ Ahụ Ike Ezinụlọ",
      "subtitle": "Hazie nlekọta mgbochi ọrịa maka ndị ezinụlọ gị",
      "addMember": "Tinye Onye Ezinụlọ",
      "memberName": "Aha Onye Ahụ",
      "relationship": "Mmekọrịta",
      "dateOfBirth": "Ụbọchị Ọmụmụ",
      "viewCalendar": "Lee Kalenda",
      "upcomingCare": "Nlekọta Na-abịa n'Ihu",
      "nothingScheduled": "Enweghị ihe e doro anya ugbua",
      "scheduleCheckup": "Dowe Oge Nnyocha",
      "relationships": {
        "child": "Nwa",
        "spouse": "Di/Nwunye",
        "parent": "Nne/Nna",
        "sibling": "Nwanne",
        "other": "Onye ọzọ"
      }
    },
    "content": {
      "infantCare": {
        "title": "Nlekọta Mgbochi Nwa Ọhụrụ",
        "intro": "Ụzọ dị mkpa isi lekọta ahụ ike nwa gị n'afọ mbụ ya",
        "topics": [
          "Usoro nnyocha ahụ ike nwa",
          "Ihe ị ga-eleba anya n'utolite nwa",
          "Ụzọ ụra dị mma",
          "Nri na inye nwa ara/nri",
          "Usoro ọgwụ mgbochi"
        ]
      },
      "childDevelopment": {
        "title": "Ntolite Nwa na Ihe Ngosi",
        "intro": "Ịghọta utolite na ntolite ahụ ike",
        "topics": [
          "Mmepe nke ahụ nwa",
          "Mmekọrịta na mmetụta uche",
          "Mmepe asụsụ",
          "Mmepe echiche na uche",
          "Oge ị ga-agwa dọkịta okwu"
        ]
      },
      "nutrition": {
        "title": "Nri na Ntolite Ahụ Ike",
        "intro": "Ịkụziri nwa àgwà iri nri dị mma site na mbido",
        "topics": [
          "Nri kwesịrị ekwesị maka afọ onye nọ",
          "Ụdị nri mgbakwunye dị mma",
          "Ịlekọta ụmụaka ndị na-anaghị eri nri ọ bụla",
          "Ịdị ọcha nke nri",
          "Ịṅụ mmiri zuru oke"
        ]
      },
      "safety": {
        "title": "Nchebe na Mgbochi Mmerụ Ahụ",
        "intro": "Ịmepụta ebe nchekwa maka ezinụlọ gị",
        "topics": [
          "Ndepụta nchebe n'ụlọ",
          "Nchebe n'oche ụgbọala",
          "Nchebe na mmiri",
          "Mgbochi iri ihe na-egbu egbu",
          "Njikere maka ihe mberede"
        ]
      }
    }
  }
};
